/* eslint-disable max-len */
const pt = {
  duplicate_denounce_warning: "Já existe uma denúncia ativa",
  duplicate_denounce_cannot_report: "Por enquanto, você não pode denunciar esta publicação.",
  no_can_report_massively_catalog_product: "Não é possível denunciar em massa porque se trata de um produto de catálogo.",
  onboarding_slide_notices: {
    step_1: {
      title: "Confira as novas funções!",
      description: "Agora ficou mais fácil traduzir a seção, ver a documentação anexada e os detalhes do anúncio denunciado.",
    },
    step_2: {
      title: "Tradução na hora",
      description: "Basta um clique para traduzir todo conteúdo da seção.",
    },
    step_3: {
      title: "Documentação disponível",
      description: "Pré-visualize as imagens que os vendedores anexam sem precisar baixá-las.",
    },
    step_4: {
      title: "Detalhes do anúncio",
      description: "Revise o anúncio que denunciou no novo módulo no final da seção.",
    },
    next: "Seguinte",
    ok: "Entendi",
  },
  catalogue: "catálogo",
  catalogue_id: "ID de catálogo",
  official_store: "loja oficial",
  international_purchase: "COMPRA INTERNACIONAL",
  article_catalogue_detail: {
    title_images: "Fotos do catálogo",
    report_images: "Marcar fotos como suspeitas",
    report_right: "Reportar infração aos meus direitos",
    article_denounced: "Esta publicación infrige mis derechos",
    sellers_title: "Vendedores participantes",
    sellers_subtitle: "Para marcar um anúncio como suspeito, clique no cartão do vendedor correspondente.",
    seller_generic_response_title: "Respostas deste vendedor",
    seller_generic_response_subtitle: "Aqui, você verá as respostas do vendedor selecionado na lista de participantes.",
    seller_response_title: "Respostas de {seller_name}",
    seller_response_subtitle: "Confira as respostas do vendedor que você selecionou para ver se há outros motivos de suspeita.",
    seller_response_title_empty: "Respostas deste vendedor",
    seller_response_subtitle_empty: "O vendedor que você selecionou ainda não respondeu nenhuma pergunta.",
    seller_history: "Ver histórico do vendedor",
    seller_sales: "Vendas",
    country_search: "Comece a pesquisa em",
    newness_box: {
      title: "Este é um anúncio de catálogo",
      subtitle: "Esta é uma página que agrupa, sob um único conteúdo, diferentes anúncios de um mesmo produto oferecidos por vendedores diferentes.",
      "item1-a": "Para denunciar as fotos do anúncio,",
      "item1-b": "selecione a opção 'Marcar como suspeito' na seção que descreve os detalhes do produto.",
      "item2-a": "Para reportar um anúncio de um vendedor específico,",
      "item2-b": "verifique a coluna 'Vendedores participantes' e clique no botão 'Marcar como suspeito'.",
      button: "Saiba mais",
      close: "Perto",
    },
    sort_sellers: {
      item1: "A-Z",
      item2: "Preço do menor para o maior",
      item3: "Preço do maior para o menor",
      item4: "Lojas oficiais primeiro",
    },
    seller_responses_search: "Procure nas respostas...",
  },
  messageBox: {
    title: "Olá!",
    subtitle: "Gostaríamos de saber como foi sua experiência com a ferramenta de denúncias. ",
    subtitleStrong: " Você teria 3 minutinhos para nos contar?",
    button1: "Sim, claro",
    button2: "Já respondi",
  },
  multiple_denounce: {
    title: "Solicitação de denúncia",
    instruction: "Selecione o tipo de infração aplicável aos produtos que você quer denunciar.",
    infraction_label: "Infração",
    infraction_placeholder: "Selecione o tipo de infração",
    error_loading_infractions: "Erro ao carregar o tipo de infração",
    error_detail_empty: "Erro ao carregar o detalhe da infração",
    detail_label: "Detalhes",
    detail_placeholder: "Inclua os detalhes da infração.",
    send_denounce: "Enviar denúncia",
    mark_as_suspicious: "Marcar como suspeitos",
    cancel: "Cancelar",
    table: {
      product: "Produto",
      country: "País",
      remove_from_selection: "Desmarcar seleção",

    },
    options: {
      no_selected: "Selecione o tipo de infração",
      report_code: {
        PPPI1: "Produto falsificado",
        PPPI2: "Uso indevido de marca",
        PPPI3: "Direito de Autor - Software",
        PPPI5: "Direito de Autor - Livros",
        PPPI6: "Direito de Autor - Imagens",
        PPPI7: "Direito de Autor - Imagem Pessoal",
        PPPI8: "Modelo ou Desenho Industrial",
        PPPI9: "Infringe patentes, modelos de utilidade ou direitos de obtentor de variedades vegetais",
        PPPI10: "Produto não destinado à venda",
        PPPI11: "Direito de Autor - Cursos",
        PPPI12: "Direito de Autor - Videogames",
        PPPI14: "Direito de Autor - Vídeos / Filmes",
        PPPI15: "Direito de Autor - Música",
        PPPI16: "Direito de Autor - Personagens",
        PPPI17: "Direito de Autor - Outros",
        PPPI18: "Direitos Conexos - Reproduções Ilegais",
        PPPI19: "Direitos Conexos - Imagem Pessoal",
        PPPI20: "Direitos Conexos - Material de Áudio",
        PPPI21: "Direitos Conexos - Material Audiovisual",
        PPPI22: "Direitos Conexos - Transmissão Ilegal",
        PPPI23: "Direitos Conexos - Dispositivo Ilegal",
        ACUERDO: "Tenho um convênio de regulação sobre este produto.",


      },
    },
    progress: {
      processing: "Processando denúncias...",
      processed: "Processadas",
      remaining: "Pendentes",
      finishing: "Finalizando...",
      completed: "Processo concluído",
      summary: "Resumo",
      successful: "Bem-sucedidas",
      failed: "Falhadas",
    },
  },
  memberJudge: {
    widget: {
      quality: "Cumprimento de boas práticas:",
      excelent: "excelente",
      good: "bom",
      regular: "regular",
      critic: "critico",
      neutral: "sem dados",
    },
    tooltip: {
      excelent: {
        title: "Suas denúncias estão corretas!",
        subtitle: "Ao denunciar, você nos ajuda a cuidar da experiência dos compradores e a proteger seus direitos de propiedade intelectual.",
        link: "Conferir recomendações",
      },
      excelentWithRestriction: {
        title: "A quantidade de denúncias pode ser limitada",
        subtitle:
          "Embora na maioria das denúncias você cumpra o processo, algumas não são feitas adequadamente. Evite esse comportamento para não sofrer novas sanções.",
      },
      good: {
        title: "Você tem a chance de melhorar suas denúncias",
        subtitle:
          "A maioria das suas denúncias se baseiam em infrações de propriedade intelectual e se você cumpre o processo, mas identificamos algumas que não foram feitas corretamente ",
      },
      goodWithRestriction: {
        title: "Você tem a chance de melhorar suas denúncias",
        subtitle: "Algumas das suas denúncias não foram feitas corretamente. Evite esse comportamento para não sofrer novas sanções.",
      },
      regular: {
        title: "Você deve melhorar suas denúncias",
        subtitle: "Certifique-se de sempre cumprir as boas práticas de BPP para denunciar e seguir o processo adequadamente.",
      },
      regularWithRestriction: {
        title: "Você deve melhorar suas denúncias",
        subtitle: "Certifique-se de sempre cumprir as boas práticas de BPP para denunciar e seguir o processo adequadamente, evitando sofrer novas sanções.",
      },
      critic: {
        title: "Você está descumprindo as boas prática de BPP",
        subtitle: "Denuncie apenas infrações de propriedade intelectual e evite usar o programa incorretamente.",
      },
      criticWithRestriction: {
        title: "Você está descumprindo as boas prática de BPP",
        subtitle: "Denuncie apenas infrações de propriedade intelectual e evite usar o programa incorretamente.",
      },
      neutral: {
        title: "Você ainda não denunciou anúncios suficientes",
        subtitle: "Quando você denunciar, vamos te ajudar caso seja necesário.",
      },
      neutralWithRestriction: {
        title: "Você ainda não denunciou anúncios suficientes",
        subtitle: "Quando você denunciar, vamos te ajudar caso seja necesário.",
      },
    },
    button2: "Revisar denúncias",
    button3: "Ir para Central de ajuda",
    button4: "Conferir recomendações",
    alerts: {
      know_more: "Saiba mais",
      new_member: {
        title: "Faça até 50 denúncias por dia",
        subtitle:
          "Para nos certificarmos de que você saiba usar o programa corretamente e de acordo com seus direitos cadastrados, permitimos que você faça até 50 denúncias por dia.",
        subtitle2: " Ao alcançar o limite, você poderá apenas marcar os anúncios como suspeitos.",
        subtitle3: "Essa medida será temporária se você concluir os processos de denúncia corretamente. ",
        subtitle3Strong_s: "Resta {number} denúncia hoje",
        subtitle3Strong_p: "Restam {number} denúncias hoje",
      },
      sleepy: {
        title: "Faça até 50 denúncias por dia",
        subtitle:
          "Como sua conta não vem sendo usada por um período prolongado, queremos nos certificar de que você pode denunciar corretamente, de acordo com seus direitos cadastrados, por isso, permitimos que você faça até 50 denúncias por dia. ",
        subtitleStrong: "Ao alcançar o limite, você poderá apenas marcar os anúncios como suspeitos",
        subtitle2: "Essa medida será temporária se você concluir os processos de denúncia corretamente.",
        subtitle2Strong_s: "Resta {number} denúncia hoje",
        subtitle2Strong_p: "Restam {number} denúncias hoje",
      },
      restricted: {
        title: "Limitamos sua quantidade de denúncias para 50 por dia",
        subtitle: "A eficiência das suas denúncias é crítica porque você não concluiu o processo de acordo com as regras do Brand Protection Program.",
        subtitle2: "Ao alcançar seu limite de denúncias, você poderá apenas marcar os anúncios como suspeitos. ",
        subtitle2Strong_s: "Resta {number} denúncia hoje",
        subtitle2Strong_p: "Restam {number} denúncias hoje",
      },
      prevent: {
        title: "Denuncie adequadamente para evitar possíveis sanções na sua conta do BPP",
        subtitle: "Durante a revisão das suas denúncias identificamos que você descumpriu nossas ",
        subtitle_link: "boas práticas",
        subtitle2: " Denuncie adequadamente, caso contrário, isso ",
        subtitle2Strong: "pode resultar na limitação do uso da ferramenta de denúncias do BPP ou suspensão temporária do programa",
        subtitle3: "Siga nossas recomendações e saiba como aproveitar sua conta ao máximo.",
        checkReport: "Revisar denúncias",
      },
      restriction: {
        title: "Limitamos temporariamente sua quantidade de denúncias para {max_denounces} por dia",
        subtitle: "Ao denunciar anúncios por motivos diferentes de infrações de propriedade intelectual, você está descumprindo nossas ",
        subtitle_link: "boas práticas",
        subtitle2: " Por isso, você tem um limite de {max_denounces} ",
        subtitle2_b: "denúncias por dia até  {date}. ",
        subtitle2Strong_s: "Resta {number} denúncia hoje",
        subtitle2Strong_p: "Restam {number} denúncias hoje",
        subtitle3: "Denuncie adequadamente e lembre-se de que repetir esse comportamento ",
        subtitle3Strong: "pode resultar novamente na limitação do uso da ferramenta de denúncias do BPP ou até na suspensão temporária do programa",
        subtitle4: " Se precisar de ajuda ou solicitar que analisemos seu caso, ",
        subtitle4_link: "fale conosco",
      },
      limitation: {
        title: "Sua conta foi suspensa temporariamente no BPP por {days} dias",
        subtitle: "Ao denunciar anúncios repetidamente por motivos diferentes de infrações de propriedade intelectual, você está descumprindo nossas ",
        subtitle_link: "boas práticas",
        subtitle2: " Por isso,  ",
        subtitle2Strong: "não será possível fazer novas denúncias até {date}",
        subtitle3: "Denuncie adequadamente e lembre-se de que repetir esse comportamento ",
        subtitle3Strong: "pode resultar na suspensão do programa",
        subtitle4: "Se precisar de ajuda ou solicitar que analisemos seu caso, ",
        subtitle4_link: "fale conosco",
      },
      suspension: {
        title: "Suspendemos sua conta para denunciar no BPP",
        subtitle: "Identificamos que você descumpriu nossos  ",
        subtitle_link: "Termos e condições",
        subtitle2: " ao denunciar anúncios repetidamente fora do escopo do BPP. Por isso,  ",
        subtitle2Strong: "sua conta para denunciar estará suspensa até que você entre em contato conosco",
        subtitle3: "Observe que você poderá apenas: ",
        subtitle3_a: "Acessar o histórico de denúncias ou gerar relatórios.",
        subtitle3_b: "Usar sua conta para falar conosco por meio do formulário.",
        subtitle4: "Revise suas denúncias e, se precisar de ajuda ou solicitar que analisemos seu caso, ",
        subtitle4_link: "fale conosco",
      },
    },
  },
  efficiency: {
    title: "Eficiência da conta",
    default: "Não há dados suficientes para avaliar a eficiência da sua conta. \n",
    high: "Parabéns, A eficiência da sua conta é muito alta. \n",
    med: "Tome cuidado, sua conta pode ser restringida. \n",
    risk: "Sua conta foi restringida. Confira os motivos da restrição. \n",
    subtitle: "Conferir eficiência. ",
    subtitle2: "Saiba mais. ",
  },
  blindage: {
    tooltip_title: "Você já denunciou esse anúncio antes",
    tooltip_content:
      "Notamos que você já havia denunciado esse anúncio com base na mesma infração, e optou por retirar a denúncia. Para denunciá-lo novamente, você deve indicar se encontrou uma infração diferente. Caso contrário, você poderá fazer uma nova denúncia a partir de ",
    tooltip_link: "Quero entrar em contato",
    modal_excel: {
      title: "Importar lista de publicaciones sospechosas",
      subtitle_errors: "Ten en cuenta que solo podrás importar archivos que hayas descargado desde esta sección.  ",
      subtitle_success: `Você poderá verificar os elementos importados na seção de "Anúncios suspeitos".`,
      subtitle_success_mark_suspicious: "Pronto! Você marcou os produtos como suspeitos.",
      notBlindages_found: "anúncios para denunciar",
      notBlindage_found: "anúncio para denunciar",
      blindages_found: "anúncios que não puderam ser processados",
      blindage_found: "anúncio que não puderam ser processado",
      blindages_found2: "Seus anúncios não puderam ser processados",
      blindage_found2: "Seu anúncio não poderia ser processado",
      blindage_content: "Notamos que você já havia denunciado esses anúncios com base na mesma infração, e optou por retirar a denúncia.",
    },
    modal_multiple: {
      title: "Anúncios suspeitos seleccionados",
      subtitle_success: `Você poderá verificar os elementos selecionados com sucessona seção de "Anúncios suspeitos".`,
      subtitle_errors: `Alguns anúncios que você selecionou têm erros. Você poderá verificar os elementos selecionados com sucessona seção de "Anúncios suspeitos".`,
      elements: "elementos seleccionados",
      element: "elemento seleccionado",
      notBlindages_found: "anúncios seleccionados com sucesso",
      notBlindage_found: "anúncio seleccionado con éxito",
      blindages_found: "anúncios que não puderam ser processados",
      blindage_found: "anúncio que não puderam ser processado",
    },
  },
  noData: {
    title: "Não há nada aqui...",
    subtitle: "Quando você denunciar anúncios, poderá encontrá-los aqui.",
  },
  UP: {
    offer_variants: "O vendedor oferece ",
    variants: "{0} variações",
    offer_variants_b: " deste produto. ",
    no_forget: "Lembre-se de revisá-las.",
    check_variants: "Revisar variações",
    suspect_btn: "Marcar como suspeita",
    seller: "Vendedor",
    sales: "+ {sales} vendas",
    denounced_images: "Denunciar imagens",
    conditions: {
      title: "Condições de venda",
      subtitle: "Confira as diferentes condições que o vendedor oferece para esta variação.",
      alert: "Observe que, se você usar a seleção em massa para denunciar as condições de venda do catálogo, alguns tipos de infração não serão aplicáveis. Acesse a página principal de cada condição para denunciá-las."
    },
    table: {
      title: "Variações",
      subtitle: "Estas são todas as variações do produto que o vendedor oferece.",
      selected: "selecionada",
      selected_p: "selecionadas",
      more_conditions: "Todas as condições de venda",
      check_variant: "Revisar variação",
      tooltip: "Você já marcou esta variação como suspeita.",
    },
  },
  Kits: {
    check_kits: " Revisar produtos do kit",
    check_product: "Revisar produto",
    count: "{count} produtos en kit",
    alert: {
      title: "Você pode denunciar os produtos que fazem parte do kit",
      subtitle: "Ao denunciar um produto que infringe seus direitos de propriedade intelectual, os kits em que ele é vendido também serão afetados.",
    }, table: {
      title: "Produtos que fazem parte do kit",
      subtitle: "Estes são todos os produtos que fazem parte do kit."
    }
  },
  similar: "ANÚNCIO AGRUPADO",
  Similar: {
    check_similar: "Revisar anúncio",
    check_similars: "Revisar anúncios semelhantes",
    sellers_history: "Ver histórico do vendedor",
    see_alls: "Ver todos os anúncios semelhantes",

    alert: {
      title: "Há {0} anúncios semelhantes a este",
      subtitle: "Outros vendedores oferecem produtos como este. Confirme se seus anúncios infringem a propriedade intelectual."
    },
    table: {
      title: "Anúncios semelhantes",
      subtitle: "Estes são os anúncios de outros vendedores.",
      publication: "Anúncio",
      seller: "Vendedor",
      review: "Revisar anúncio"
    },
    search: {
      title: "Anúncios semelhantes",
      subtitle: "Anúncios de outros vendedores semelhantes a "
    }
  },
  "description-text": "Descrição",
  "attributes-text": "Características",
  today: "hoje",
  tomorrow: "amanhã",
  "see-details-denounced-onboarding": "Consulte os detalhes",
  "see-details-denounced-onboarding-description": "Acesse o anúncio denunciado e lembre-se do motivo de cada denúncia.",
  "denounced-details-analyce-onboarding": "Analise a resposta",
  "denounced-details-check-onboarding": "Revise as alterações feitas pelo vendedor, seus documentos e seu histórico de denúncias.",
  "denounced-detail-send-answer-onboarding": "Envie sua resposta",
  "denounced-detail-send-answer-onboarding-description": "Confirme ou retire sua denúncia depois de analisar a resposta do vendedor.",
  "redesigned-the-section": "Repaginamos a seção!",
  "redesigned-the-section-description": "Agora, ficou mais fácil para você analisar cada resposta.",
  "your-denounced-ordered": "Suas denúncias bem organizadas",
  "your-denounced-ordered-description": "As denúncias que expiram logo aparecem primeiro para que nenhuma seja esquecida.",
  "your-answers-informed": "Analise todos os detalhes",
  "your-answers-informed-description": "Consulte no mesmo lugar os detalhes da denúncia e a resposta do vendedor.",
  "complaint-management": "Gerenciamento de reclamações",
  "complaint-management-answer":
    "Aqui você poderá acompanhar a situação de suas reclamações e responder aos vendedores para decidir se deseja confirmar ou retirar sua reclamação.",
  "answers-to-be-reviewed": "Respostas a serem revistas",
  "answers-to-be-reviewed-answer":
    "Exibe uma tabela com todas as reclamações onde você recebeu uma resposta do vendedor. Clique no botão 'Analyze Response' para ver seus detalhes.",
  "analyze-response": "Analisar a resposta",
  "analyze-response-answer":
    "Aqui você verá os detalhes do relatório que você fez, assim como os detalhes do vendedor que publicou o produto que você relatou.",
  "analyze-response-answer-two": "Nesta seção você pode ver os comentários ou anexos que o vendedor lhe enviou em resposta.",
  "complaint-management-image-1": "pending_notices_PT.jpg",
  "complaint-management-image-2": "pending_notices_res_PT.jpg",
  "detail-answer-positive-one": "Se você acha que sua resposta é suficiente",
  "detail-answer-positive-two": "e você quer retirar sua reclamação, você tem que retirar sua reclamação.",
  "detail-answer-negative-one": "Se você considerar a resposta do vendedor insuficiente,",
  "detail-answer-negative-two":
    "você terá que confirmar seu relatório. Neste caso, pediremos também que você selecione o motivo pelo qual rejeitou a resposta do vendedor.",
  "closed-complaints": "Reclamações fechadas",
  "closed-complaints-answer":
    "Aqui você pode consultar o histórico de suas reclamações fechadas. Os relatórios fechados são aqueles que terminam porque você já respondeu ao vendedor, porque nós o rejeitamos ou porque já encerramos o vendedor ou a publicação.",
  "publication-detail-text": "Detalhe do anúncio",
  "comment-pending": "Comentário",
  "optional-option": "Opcional",
  "send-answer-pending": "Enviar resposta",
  pending_textarea_placeholder: "Conte ao vendedor mais detalhes sobre sua decisão.",
  "comment-detail-pending": "Revise a resposta do vendedor antes de tomar sua decisão.",
  "answer-for-seller": "Resposta para o vendedor",
  "confirm-report": "Confirmar denúncia",
  "retract-report": "Retirar denúncia",
  "reason-for-confirmation": "Motivo da confirmação",
  "incorrect-documentation": "A documentação não corresponde ao produto relatado",
  "unreadable-documentation": "A documentação não pode ser lida",
  "unauthorized-user-document": "Você não está autorizado a usar este conteúdo",
  "does-not-justify-stock": "Não justifica o estoque",
  "counterfeited-buy": "Você faz uma compra e ela é falsificada",
  "luxury-product-with-a-lot-stock": "É um produto de luxo com muito estoque",
  "low-average-price": "É de preço abaixo do normal",
  "comments-seller-null": "O vendedor não fez comentários",
  "list-to-back-closed-denounced": "Veja a lista de relatórios fechados",
  "list-to-back-pending-denounced": "Veja a lista de relatórios encostas",
  "list-to-back-noticed-denounced": "Voltar para lista",
  "denounced-state": "Status da reclamação",
  rollbackeable: "Quero reativar este anúncio. ",
  "rollback-tooltip": "Marque esta opção se quiser retirar esta denúncia e reativar o anúncio. ",
  "rollbackeable-description-title": "Motivo da retirada",
  "rollback-placeholder": "Por favor, informe os motivos por ter retirado a denúncia",
  "rollback-case": "Reativar anúncio",
  "rollback-success": "Pronto! A denúncia foi retirada. ",
  "rollback-error": "Não foi possível salvar suas alterações. Por favor, tente novamente. ",
  "retracted-reason-title": "Motivo da retirada:",
  "see-documentation": "Ver documentação",
  "attached-documentation": "Documentação anexada",
  "see-images-updated": "Ver imagens modificadas",
  "images-updated": "Imagens alteradas",
  "reported-images": "Imagens denunciadas",
  "actual-images": "Imagens atuais",
  "commets-seller": "Comentário do vendedor",
  "sellers-history": "História do vendedor",
  "sellers-history-modal": {
    title: "Denúncias recebidas pelo vendedor",
    subtitle: "É o histórico das denúncias mais recentes recebidas por este vendedor, tanto as enviadas por você como por outros titulares de direito.",
    receive_s: "denúncia recebida",
    receive_p: "denúncias recebidas",
    receive_n: "Nenhuma denúncia recebida",
    sent_s: "resposta enviada",
    sent_p: "respostas enviadas",
    accepted_s: "resposta aceita",
    accepted_p: "respostas aceitas",
    table: {
      th1: "Anúncio",
      th2: "Relatório",
      th3: "Motivo da denúncia",
      th4: "Resposta do vendedor",
    },
  },
  "translate-contents": "Traduzir conteúdos",
  "answer-seller": "Resposta do vendedor",
  "see-ofert-auditor": "Ver comentário do auditor",
  "see-ofert-auditor-up": "Revisar comentario del auditor",
  "auditor-comment": "Comentário do auditor",
  "auditor-said": "disse",
  "motif-denounced": "Motivo da reclamação",
  "see-publication": "Ver publicação denunciada",
  "download-screenshot": "Baixar captura",
  "denounced-publication": "Publicação denunciada",
  "denounced-publications": "Publicaciónes denunciadas",
  "denounced-variants": "Variações denunciadas",
  "denounced-variants-count": "Você denunciou {count} variações deste produto.",
  "send-answer-condition": "Se você não responder antes da data de expiração, a publicação será mostrada novamente no Mercado Libre",
  "send-answer": "Envie sua resposta ao vendedor",
  "closed-title": "Denúncia encerrada",
  "closed-subtitle": "Você pode consultar os detalhes e retirar a sua denúncia, mas não pode se comunicar com o vendedor.",
  "rejected-title": "Não foi possível processar a denúncia",
  "rejected-subtitle": "Verifique no status da denúncia o motivo pelo qual não pudemos processá-la.",
  expires_text: "expira",
  "back-to-list": "Voltar para a lista",
  "see-report": "ver relatório",
  answer: "Responder",
  see: "Conferir",
  "analyse-response": "Analisar resposta",
  expires: "Expira",
  motif: "Motivo",
  action: "Ação",
  statusMsgPaused: "Anúncio pausado",
  automation: {
    newbie: {
      title: "Você atingiu o limite de 50 denúncias diárias. Só é possível denunciar amanhã ",
      text1: "Isso acontece porque sua conta e nova e precisamos conferir se as denúncias que você fez correspondem aos direitos cadastrados",
      text2: "Hoje, só é possivel marcar anúncios como suspeitos",
      button: "Ver mais.",
    },
    newbieInfo: {
      title: "Você pode fazer até 50 denúncias por dia",
      text1: "Isso acontece porque sua conta é nova e precisamos conferir se as denúncias que você fez correspondem aos direitos cadastrados",
      text2: "Ainda é possível fazer {denounces} denúncias hoje.",
      text3: "Depois, você só poderá marcar os anúncios como suspeitos",
      button: "Ver mais",
    },
    pending_cn: {
      title: "Você tem {30} respostas de vendedores que vencem hoje",
      text1:
        "Você deve revisar e respondê-las para poder continuar fazendo denúncias. Caso contrário, os anúncios denunciados serão reativados automaticamente.",
      text2: "Lembre-se de que, após recebê-las, você tem 4 dias para analisar a resposta dos vendedores.",
      button: "Responder",
    },
    limited_by_inefficient: {
      with_denounces_p: {
        title: "O limite de denúncias da sua conta foi restrito a 50 por dia",
        text1: "Isso acontece porque a eficiência da sua conta é muito baixa.",
        text2: "Ainda é possível fazer {number} denúncias hoje.",
        text3: "Depois, você só poderá marcar os anúncios como suspeitos.",
        button: "Ver mais",
      },
      with_denounces_s: {
        title: "O limite de denúncias da sua conta foi restrito a 50 por dia",
        text1: "Isso acontece porque a eficiência da sua conta é muito baixa.",
        text2: "Ainda é possível fazer {number} denúncia hoje.",
        text3: "Depois, você só poderá marcar os anúncios como suspeitos.",
        button: "Ver mais",
      },
      without_denounces: {
        title: "Você atingiu o limite de denúncias diárias",
        text1: "Hoje, só será possível marcar anúncios como suspeitos",
        text2: "Recomendamos que você confira a seção de eficiência para saber os motivos pelos quais sua conta foi restringida",
        button: "Ver mais",
      },
      general: {
        text3: "Confira seu histórico para mais informações.",
        button1: "Ir para o Histórico de denúncias",
        button2: "Ver mais",
      },
      day_limit: {
        title: "Você não poderá fazer mais denúncias pelo resto do dia",
        text1: "Você já denunciou sua quantidade máxima diária de 30.000 anúncios.",
        text2: "Lembre-se de que, mesmo assim, você poderá marcar anúncios como suspeitos, mas não poderá enviar as denúncias até amanhã.",
      },
    },
    items_inactive: {
      case_1: "Hoje você pode enviar somente {50} denúncias.",
      case_2: {
        text1: "Você já enviou {20} das suas {50} denúncias máximas diárias.",
        text2: "Restam {30}.",
      },
      case_3: {
        text1: "Você já denunciou seu número máximo diário de {50} anúncios.",
        text2: "Você não pode fazer mais denúncias pelo restante do dia.",
      },
      tooltip: "Restringimos suas denúncias, pois mais de 60% delas foram recusadas nos últimos 2 meses.",
    },
    generic: {
      title: "Você não pode mais fazer denúncias",
      text: "Lembre-se de que você poderá marcar anúncios como suspeitos, mas não poderá enviar as denúncias até o dia {date}.",
    },
    tooltip_all: {
      title: "Você quer enviar todas as denúncias?",
      body: "Após enviá-las, vamos notificar o vendedor para enviar sua resposta.",
      ok: "Enviar denúncias",
      cancel: "Cancelar",
    },
    tooltip_partial: {
      title_p: "Você pode enviar apenas {10} denúncias",
      title_s: "Você pode enviar apenas 1 denúncia",
      body_1: "Os anúncios que você selecionou excedem o limite de denúncias diárias, ",
      body_2: "mas mesmo assim você pode enviar {10}.",
      ok_p: "Enviar {10} denúncias",
      ok_s: "Enviar 1 denúncia",
      cancel: "Cancelar",
    },
  },
  counter_notice_new_deadline_1: "Mudamos os prazos para responder denúncias.",
  counter_notice_new_deadline_2: "Agora, você terá 4 dias para revisar a resposta dos vendedores.",
  article_detail: {
    breadcrumb_label: "Detalhe do item",
    description: "Descrição",
    description_up: "Descrição do produto",
    questions: "Perguntas",
    empty_description: "O vendedor não inseriu a descrição do produto.",
    back_to_results: "Voltar aos resultados",
    back_to_suggested_listings: "Voltar aos anúncios sugeridos",
    view_all_description: "Ver a descrição completa",
    last_questions: "Últimas perguntas",
    empty_questions: "Ninguém fez perguntas ainda.",
    view_more_questions: "Veja mais perguntas",
    marked_as_suspicious: "Anúncio marcado como suspeito",
    motive: "Motivo",
    marked_as_trusted: "Anúncio marcado como confiável",
    by: "por",
  },
  seller_detail: {
    "": "",
  },
  mark_as_suspicious_label: "Suspeito",
  mark_as_trusted_label: "Confiável",
  mark_as_catalogo_label: "Veja detalhes",
  original: "Orig",
  translation: "Tradução",
  translate_click_here_original: "Ver original",
  translate_click_here_translated: "Ver tradução",
  maintenance: {
    we_are_working: "Estamos fazendo melhorias!",
    come_back_soon: "Volte em breve e reinicie sua sessão para conferir tudo!",
    maintenance_in_progress: "Estamos realizando tarefas de manutenção. Pedimos desculpas pelos transtornos ocasionados.",
  },
  all_auditors: "Todos os auditores",
  there_are_not_listings_that_match: "Não há anúncios que correspondam à sua busca",
  view_more: "ver mais...",
  know_more: "Conoce más",
  view_more_suggested: "Ver mais sugeridos",
  view_all: "Ver todos",
  video_tutotial_link: "https://www.youtube.com/embed/dYEU82XeLcE?rel=0&amp;showinfo=0",
  title_snapshot_dowload: "Download de Snapshot",
  snapshot_dowload_error: "Ocorreu um erro ao obter o link de download, tente mais tarde.",
  snapshot_link_label: "Clique aqui para baixar o snapshot",
  new_content_available: "Novo conteúdo disponível",
  check_report_codes_for: "Verifique se você possui códigos de reclamação para os seguintes países: ",
  no_report_codes_available_for: "Você não tem códigos de reclamação para ",
  about_to_delete_live_search: "Deseja deletar essa Livesearch?",
  activate_all: "Ativar todos",
  countries_toggle_info: "Clique nos países onde você quer excluir da sua busca. Para desmarcar todos, por favor, use o botão abaixo.",
  authorize_btn: "Clique aqui para autorizar",
  message_authorize: "Você ainda deve autorizar os seguintes países a pesquisar e relatar sobre eles",
  activate_none: "Desativar todos",
  expand: "Expandir",
  collapse: "Colapsar",
  activity: "Atividade",
  activity_uppercase: "ATIVIDADE",
  apply: "Aplicar",
  apply_filters: "Aplicar alterações e atualizar os artigos",
  apply_filters_error: "Sentimos muito, mas não podemos aplicar os filtros. Por favor, tente novamente.",
  applying_filters: "Aplicando filtros",
  are_you_sure: "Tem certeza?",
  question_send_all_notices: "Tem certeza?",
  article: "artigo",
  disabled_article: "postagem desativada",
  article_change_status_error: "Sentimos muito, mas não podemos alterar o estado de artigo",
  article_change_status_error_already: "Já foi auditado dentro de sua organização.",
  articles_change_status_error: "Sentimos muito, mas não podemos alterar o estado de os artigos",
  articles_change_status_error_already: "Eles já foram auditados dentro de sua organização.",
  article_drop: "baixa",
  article_drops: "baixas",
  article_from_white_seller: "Vendedor Objetado",
  article_ok: "Artigo Válido",
  article_invalid: "Não é possível denunciar este anúncio",
  article_reference: "Id",
  article_brand_name: "Marca",
  article_part_name: "Número de peça",
  article_type: "Tipo de Produto",
  article_without_picture: "ARTIGO SEM FOTO",
  in_moderation_card_title: "Denúncia enviada",
  in_moderation_card_text_1: "Confira o status das suas denúncias no ",
  in_moderation_card_text_2: "Histórico de denúncias.",
  in_moderation_card_text_3: "",
  articles_to_ok_warn: "Você esta a ponto de alterar o estado do Artigo para OK. Essa ação não se pode ser desfeita.",
  articles_to_pending_warn: "O Artigo voltará ao estado pendente e perderá a informação da denuncia. Tem certeza?",
  mark: "Marcar",
  articles_to_report: "anúncios como suspeitos",
  article_to_report: "anúncio como suspeito",
  articles_to_report_menu: "Denunciar anúncios suspeitos",
  articles_to_report_sub: "Revise e envie suas denúncias.",
  articles_to_report_short: "Art. para denunciar",
  audited: "Auditados",
  audited_batch_title: "Auditados em modo seleção multipla",
  result: "Resultado",
  results: "Resultados",
  ready_to_audit: "PRONTO PARA AUDITAR",
  available_quantity: "disponíveis",
  avoided_words: "Palavras para evitar",
  batch_mode: "Seleção múltipla",
  batch_mode_info: "Selecione diversos anúncios clicando no botão de Seleção Múltipla e, em seguida, nos polegares para cima ou para baixo.",
  deselect_current_page: "Desselecionar esta página",
  deselect_all: "Desselecionar tudo",
  select_products_to_report_same_infringement: "Selecione produtos para denunciar pelo mesmo tipo de infração.",
  selected_singular: "selecionado",
  selected_plural: "selecionados",
  brand: "Marca",
  brands: "Marcas",
  ok: "Sim",
  accept: "Aceitar",
  cancel: "Cancelar",
  cancel_batch_warning: "Ira perder todas as publicações selecionadas. Tem certeza?",
  category: "Categoria",
  choose_another_brand: "Selecionar outra marca",
  choose_brand: "Selecione uma marca",
  condition_all: "Todos",
  condition_from_blacklisted_sellers: "De Vendedores Observados",
  condition_new: "Novo",
  condition_used: "Usado",
  condition_refurbished: "Recondicionado",
  "official-store": "Produto Oficial da Loja",
  "switch-translate": {
    label: "Traduzir anúncio",
    tooltip: {
      title: "Traduzir este anúncio",
      description: "Ative nosso tradutor e analise melhor a sua denúncia.",
      button: "Entendi",
    },
    tooltip_2: {
      title: "Desativamos esta função enquanto a denúncia é feita",
      description: "Isso foi feito para que você possa analisar e marcar violações sobre os textos originais.",
      button: "Entendi",
    },
    snack_message: {
      title: "Esta é uma tradução automática e pode conter erros",
      description:
        "Por favor, observe que a funcionalidade é um serviço prestado por terceiros e não deve ser considerada uma tradução oficial. É apenas uma sugestão e seu uso não é obrigatório.",
    },
    error: "Tivemos um problema e não foi possível carregar sua tradução. Por favor, tente novamente.",
  },
  languages: {
    es: "Español",
    en: "Inglés",
    pt: "Portugués",
  },
  countries: {
    AA: "Global",
    AR: "Argentina",
    AT: "Áustria",
    BE: "Bélgica",
    BO: "Bolívia",
    BR: "Brasil",
    CA: "Canadá",
    CH: "Suíça",
    CL: "Chile",
    CO: "Colômbia",
    CR: "Costa Rica",
    DE: "Alemanha",
    DO: "República Dominicana",
    RD: "República Dominicana",
    EC: "Equador",
    EN: "Inglaterra",
    ES: "Espanha",
    FR: "França",
    GB: "Reino Unido",
    GT: "Guatemala",
    HN: "Honduras",
    IE: "Irlanda",
    IT: "Itália",
    MX: "México",
    NI: "Nicarágua",
    NL: "Holanda",
    PA: "Panamá",
    PE: "Peru",
    PR: "Puerto Rico",
    PT: "Portugal",
    PY: "Paraguai",
    SC: "Escócia",
    SV: "El Salvador",
    US: "EUA",
    UY: "Uruguai",
    VE: "Venezuela",
  },
  countries_legal: {
    AR: "Argentina",
    BO: "Bolívia",
    BR: "Brasil",
    CL: "Chile",
    CO: "Colômbia",
    CR: "Costa Rica",
    DO: "Dominicana",
    EC: "Equador",
    GT: "Guatemala",
    HN: "Honduras",
    MX: "México",
    NI: "Nicarágua",
    PA: "Panamá",
    PE: "Peru",
    PY: "Paraguai",
    SV: "El Salvador",
    UY: "Uruguai",
    VE: "Venezuela",
  },
  country: "País",
  countries_select: "Países",
  country_selector_clarification: "Selecione os países em que você deseja pesquisar",
  all_the_countries: "Todos os países",
  create_live_search_with_current_listings: "Criar Livesearch dos artigos Atuais",
  create_report_results: "Gerar resultados do Livesearch",
  create_livesearch_report_created: "Relatório criado com sucesso.",
  create_livesearch_report_error: "Ocorreu um erro ao criar o relatório.",
  go_to_ls_reports: "Ir para os relatórios do Livesearch",
  create_search_of_black_sellers: "Criar Livesearch de todos os Vendedores Observados",
  creating: "criando",
  currency_report_results: "Selecione a moeda para a apresentação dos resultados",
  current_listings: "Artigos Atuais",
  onboarding_slide: {
    skip: "Omitir",
    start: "Começar",
    slide1: {
      title: "Antes de começar...",
      text: "Oferecemos algumas dicas para que você possa aproveitar nossa ferramenta ao máximo.",
    },
    slide2: {
      title: "Faça buscas em massa",
      text: "Use o campo de busca para encontrar infrações em qualquer site do Mercado Livre.",
      image: "slide1-pt.png",
    },
    slide3: {
      title: "Crie seus filtros de busca",
      text: "Personalize suas buscas para encontrar infrações mais rápido e facilmente.",
      image: "slide2-pt.png",
    },
    slide4: {
      title: "Diversas denúncias de uma só vez",
      text: "Denuncie diversos anúncios em uma mesma tela e em poucos cliques.",
      image: "slide3-pt.png",
    },
    slide5: {
      title: "Envie todas as suas denúncias",
      text: "Quando estiver com tudo pronto para enviar suas denúncias, pode confirmar uma a uma ou todas de uma só vez.",
      image: "slide4-pt.png",
    },
    slide6: {
      title: "Pronto! Comece a denunciar",
      text: "Lembre-se que, em caso de dúvidas, basta acessar a seção de Ajuda no menu.",
    },
  },
  re_branding: {
    modal_title: "Agora somos o Brand Protection Program do Mercado Livre",
    bullet_1: {
      title: "Novo nome",
      subtitle: "O Programa de Proteção à Propriedade Intelectual agora se chama Brand Protection Program.",
    },
    bullet_2: {
      title: "Novo site",
      subtitle: "Agora, com mais informações e respostas para as perguntas mais frequentes.",
    },
    bullet_3: {
      title: "O compromisso de sempre",
      subtitle: "Continuamos trabalhando para melhorar o  programa e tornar o processo de denúncias cada vez mais fácil.",
    },
    check_out_what_is_new: "Confira todas as novidades!",
    go_to_bpp_site: "Ir para o site",
  },
  livesearch_onboarding: {
    title: "Simplificamos o processo para denunciar produtos",
    description: "Confira uma nova forma mais rápida de também fazer suas denúncias. ",
    start_button: "Começar",
  },
  livesearch_step_by_step: {
    of: "de",
    previous: "Anterior",
    next: "Seguinte",
    finish: "Entendi",
    step1: {
      title: "Selecione os produtos para denunciar",
      description: "Escolha todos os que você considera que estão cometendo o mesmo tipo de infração.",
    },
    step2: {
      title: "Verifique a seleção e solicite a denúncia",
      description: "Quando fizer a solicitação, escolha o motivo, inclua detalhes e envie, ou marque produtos como suspeitos para denunciar depois.",
    },
  },
  fotoproducto_tutorial: {
    intro: {
      title: "Agora você pode denunciar as fotografias dos produtos",
      description: "Selecione \"Foto de produto\" se encontrar fotos com sua marca visível usada sem autorização.",
      start_button: "Começar",
    },
    step1: {
      title: "Selecione \"Foto de produto\"",
      description: "Escolha esta opção para denunciar as imagens que usem sua marca sem autorização.",
    },
    step2: {
      title: "Escolha as fotos para denunciar",
      description: "Revise o anúncio e escolha as fotos em que sua marca aparece sem permissão.",
    },
    step3: {
      title: "Complete e envie sua denúncia",
      description: "Detalhe como estão usando sua marca sem permissão e escolha o documento de suporte que você vai adicionar.",
    },
    of: "de",
    previous: "Anterior",
    next: "Próximo",
    finish: "Entendido",
  },
  suggestions_slide: {
    next: "Próximo",
    start: "Entendi",
    new_user: {
      slide1: {
        title: "Uma nova forma de denunciar",
        text: "Analise anúncios que detectamos automaticamente, com base nos nossos processos e no seu histórico de denúncias.",
      },
      slide2: {
        title: "Quanto mais analisar, melhores serão as sugestões",
        text: "Com suas denúncias, aprendemos para continuar melhorando nossas detecções e atualizar suas recomendações.",
      },
      slide3: {
        title: "Novo! Filtre por país e continue denunciando",
        text: "Encontre anúncios sugeridos em países do seu interesse e observe o progresso das suas denúncias da última semana.",
      },
    },
    old_user: {
      tag_text: "Novo!",
      slide1: {
        title: "Filtre por país e continue denunciando",
        text: "Encontre anúncios sugeridos em países do seu interesse e observe o progresso das suas denúncias da última semana.",
      },
    },
  },
  verify_profile: {
    title: "Atualize os dados da sua conta",
    subtitle: "Para que possamos continuar processando suas denúncias corretamente, precisamos que você atualize suas informações.",
    expires: "Você tem até o dia",
    verify_btn: "Atualizar dados",
    remind_later: "Lembrar mais tarde",
    alert: {
      main_text: "Atualize os dados da sua conta.",
      secondary_text: "Certifique-se de que suas informações estejam completas para que possamos continuar processando suas denúncias.",
      review_data: "Atualizar dados",
    },
    form: {
      title: "Perfil da conta",
      subtitle: "Atualize os dados da sua conta. Lembre-se de que ",
      subtitle_b: "você não poderá editar após confirmar esses dados.",
      confirm: "Confirme",
      account_type: {
        verified_title: "Tipo de usuário",
        title: "Que tipo de usuário você quer cadastrar?",
        item_titular: "Sou titular de direitos ou representante legal",
        helper_titular: "Ou seja, você é o proprietário ou representante legal dos direitos a serem cadastrados.",
        item_apoderado: "Sou procurador dos direitos",
        helper_apoderado: "Ou seja, você é pessoa física ou jurídica autorizada pelo titular dos direitos para agir em seu nome.",
      },
      attorney_accreditation: {
        title: "Valide-se como procurador",
        name: "Nome do procurador:",
        name_helper: "Pode ser uma pessoa física ou empresa.",
        subtitle: "Dados de contato do titular",
        subtitle_helper_1: "opcional",
        subtitle_helper_2: "Pode ser o gerente de proteção de marcas ou advogado de propriedade intelectual.",
        contact_name: "Nome do contato",
        email: "E-mail",
      },
      account_info: {
        title: "Informações sobre a conta",
        subtitle: "O titular de direitos é:",
        natural: "Pessoa física",
        legal: "Pessoa jurídica",
        physical_fields: {
          name: "Nome completo",
          country: "País",
          type: "Tipo de identificação",
          number: "Número de identificação",
        },
        legal_fields: {
          name: "Nome ou razão social",
          country: "País",
          type: "Tipo de identificação tributária",
          number: "Número de identificação tributária",
        },
      },
      attorney_contact: {
        title: "Contato do representante",
        helper: "Esses são os dados que usaremos no Mercado Livre para entrar em contato com o representante ou administrador da conta.",
        name: "Nome completo",
        code: "DDI",
        tel: "Telefone",
        tel_helper: "Inclua o DDD.",
        email: "E-mail corporativo",
        email_ex: "Por exemplo, joao.silva@suaempresa.com",
        lang: "Idioma de contato",
        lang_placeholder: "Selecione",
      },
      public_data: {
        title: "Dados públicos",
        helper:
          "Esses são os dados que enviaremos ao vendedor denunciado para que ele possa entrar em contato com você assim que o processo de denúncia estiver concluído. Informe o nome da marca ou do grupo econômico para que o vendedor saiba quem está denunciando.",
        name: "Nome a mostrar",
        email: "E-mail",
        email_helper: "Pode ser genérico e não deve ser um email já registrado no Mercado Livre.",
      },
      exit_modal: {
        title: "Você quer sair do formulário?",
        text: "Se abandonar a página, você deverá preencher todos os dados novamente.",
        back: "Voltar",
        exit: "Sair",
      },
      success: {
        text: "Pronto! Já atualizamos seus dados.",
      },
      error_email: {
        text: "O e-mail inserido já está cadastrado no Mercado Livre. Por favor, insira outro.",
      },
    },
  },
  suggested_listings: {
    title: "Anúncios sugeridos",
    subtitle_p: "Nesta seção, você verá os anúncios que encontramos com base nas nossas detecções e seu histórico de denúncias.",
    subtitle_s: "São anúncios que encontramos com base nas nossas detecções e seu histórico de denúncias.",
    stats: {
      box_1: {
        text1_p: "anúncios para denunciar",
        text1_s: "dos anúncios analisados",
        text2: "Denunciar",
      },
      box_2: {
        text1: "Seu progresso nos últimos 7 dias",
        text2_p: "marcados como suspeitos",
        text2_s: "marcado como suspeito",
        text3_p: "marcados como confiáveis",
        text3_s: "marcado como confiável",
        text4: "Evolução das reclamações",
        text5: "hoje",
      },
      tooltip_p: "anúncios denunciados",
      tooltip_s: "por denunciar",
    },
    item1s: "dos anúncios analisados",
    item2s: "marcado como confiável",
    item3s1: "marcado como suspeito",
    item3s2: "Denunciar",
    item1p: "dos anúncios analisados",
    item2p: "marcados como confiáveis",
    item3p1: "marcados como suspeitos",
    item3p2: "Denunciar",
    not_results_title: "Você não tem mais sugestões de anúncios!",
    not_results_link_label: "Fazer uma busca",
  },
  suggested_discard: {
    text_btn: "Excluir anúncio",
    tooltip: {
      title: "Não tem certeza do que fazer?",
      description: "Agora você pode excluir o anúncio para que deixemos de exibi-lo nos seus resultados.",
    },
    modal: {
      title: "Por que você quer excluir este anúncio?",
      subtitle: "Lembre-se de que voltaremos a exibi-lo nos seus resultados de busca se o vendedor o alterar ou receber novas perguntas.",
      discard_item: {
        item1: "Não tenho certeza que tem uma infração",
        item2: "O anúncio ou o produto não corresponde aos meus direitos cadastrados",
        item3: "O anúncio ou o produto não é relevante para o meu negócio",
        item4: "Outro motivo",
        item1_subtext: "Ou seja, você não encontrou evidências precisas de que o produto é falsificado, de infrações de propriedade intelectual etc.",
        item2_subtext: "Ou seja, os direitos que você têm não permitem que você denuncie infrações sobre este anúncio ou produto.",
        item3_subtext: "Ou seja, não é o foco principal da marca ou da sua operação.",
        item4_subtext: "",
      },
      step_2: {
        title: "Pode nos contar um pouco mais?",
        subtitle: "(Opcional)",
        placeholder: "Conte-nos por que você quer excluir o anúncio.",
        btn_text: "Excluir anúncio",
      },
    },
    done_article_discarded: "Feito! Se o anúncio tiver alterações, voltaremos a exibi-lo para você.",
  },
  file_uploader: {
    formats: "Formatos",
    maximum_size: "Tamanho máximo",
  },
  xlsx_import_success: {
    done: "Pronto!",
    marked_listing: "Você marcou 1 anúncio como suspeito.",
    marked_listings: "Você marcou {0} anúncios como suspeitos.",
    go_to_report: "Denunciar",
  },
  add_suspicious_xlsx: {
    alert_easier: "Denunciar em massa já está mais fácil.",
    alert_info: "Agora, você pode enviar uma planilha com todos os anúncios que quiser denunciar.",
    alert_btn_label: "Enviar em massa",
    tooltip_onboarding_title: "Precisa importar uma lista?",
    tooltip_onboarding_text: "Agora você pode baixar sua planilha Excel de anúncios suspeitos nesta seção.",
    tootip_btn_title: "Baixe aqui sua panilha",
    tootip_btn_text: "Você poderá importar somente arquivos que tenha baixado aqui.",
    modal_title: "Importar lista de anúncios suspeitos",
    modal_subtitle_text1: "Observe que você só poderá importar arquivos que foram baixados a partir desta seção.",
    modal_subtitle_text2: "Baixe sua planilha de Excel",
    btn_import: "Enviar arquivo",
    elements: "elementos importados",
    element: "elemento importado",
    listings_found: "anúncios importados com sucesso",
    listing_found: "anúncio importado com sucesso",
    errors: "Errores",
    error: "anúncio que não puderam ser processado",
    listings_duplicated: "anúncios já marcados como suspeitos",
    listing_duplicated: "anúncio já marcado como suspeito",
    editable_catalog_accepted: "catálogo editável aceito",
    editable_catalogs_accepted: "catálogos editáveis aceitos",
    pure_catalog_rejected: "anúncio de catálogo",
    pure_catalogs_rejected: "anúncios de catálogo",
    catalog_listings: "Anúncios de catálogo",
    download_detail: "Baixe a planilha para verificar os erros",
    process_results_title: "Carregamos dados com sucesso",
    found_count_label: "Número de publicações que você pode adicionar: ",
    not_found_count_label: "Número de publicações que não encontramos: ",
    invalid_count_label: "Quantidade de IDs inválidos: ",
    how_to_title: "Diretrizes para criar a lista",
    how_to_bullet_1: "Inclua um anúncio por linha.",
    how_to_bullet_2: "Você pode incluir o ID do anúncio ou o URL.",
    how_to_bullet_3: "Adicione somente anúncios do mesmo país.",
    how_to_bullet_4: "Você pode importar no máximo 1000 anúncios por vez.",
    how_to_bullet_5: "Certifique-se de que todos os anúncios tenham o mesmo motivo de denúncia.",
    how_to_important: "Importante!",
    how_to_download: "Baixar exemplo",
    processing: "Em processamento",
    empty_text: "Adicionar arquivo",
    empty_drag_text: "Você também pode arrastá-los",
    on_drag_text: "Solte o arquivo aqui para processá-lo",
    drag_file_too_large: "O arquivo é muito pesado",
    error_reading_file: "Não foi possível revisar os anúncios. Por favor, tente novamente mais tarde.",
    only_duplicated_listings_message: "Os anúncios já estão marcados como suspeitos.",
    only_duplicated_listing_message: "O anúncio já está marcado como suspeito.",
    not_enrolled_rigths_listings_message: "Os anúncios são de um país onde você não possui direitos cadastrados.",
    not_enrolled_rigths_listing_message: "O anúncio é de um país onde você não possui direitos cadastrados.",
    not_valid_found_message: "Não encontramos anúncios com os IDs ou URLs adicionados.",
    only_one_site: "O arquivo contém anúncios de mais de um país.",
    only_one_file: "Não é possível enviar mais de um arquivo por vez.",
    incorrect_file_format: "O formato do arquivo é incorreto",
    too_many_message: "O arquivo contém mais de 1000 componentes",
    file_exceeds_maximum_size: "O arquivo excede o tamanho máximo.",
    reason_select: "Selecione o motivo da reclamação",
    reason_no_selected: "O motivo não foi selecionado",
    comment_title: "Adicionar comentário",
    comment_description: "Aquí puedes agregar un comentario que acompañe a tu denuncia",
    comment_warning: "O texto deve ter pelo menos 5 caracteres.",
    valid_charters: "Apenas os seguintes caracteres são permitidos: A-Z a-z 0-9 . , ' & \" - _",
  },
  live_search_report_form: {
    new_report: "Novo Relatório",
    source: "Fonte",
    option_meli_dump: "Dump",
    option_meli_api: "API",
    search_word: "Prazo para pesquisar",
    nickname_seller: "Nickname do Vendedor",
    listing_state: "Estado das publicações",
    all: "Todas",
    active: "Ativo",
    paused: "Em Pausa",
    countries: "Países",
    no_countries: "Nenhum país selecionado",
    preview: "Aplicar e pesquisar",
    create: "Criar relatório",
    selected_country: "país selecionado",
    selected_countries: "países selecionados",
    clarification: "O relatório gerado usando dados atualizados uma vez por dia.",
  },
  denunciated: "denunciados",
  denunciation: "denuncia",
  download_report_results: "Baixar Resultados do Relatório",
  ebay: "eBay",
  edit: "Editar",
  email: "Email",
  enter_keyword_for_live_search: "Selecione o critério de busca",
  start_the_search_in: "Começar a busca em ",
  stored_searches: "Buscas salvas",
  export_data: {
    reports: {
      all_sellers: "Todos os vendedores",
      audits_by: "Auditadas por",
      avoid_words: "Evitar palavras",
      blacklisted_sellers: "Vendedores na lista negra",
      brand: "Marca",
      city: "Ciudade",
      brands: "Marcas",
      ok: "Sim",
      accept: "Aceitar",
      cancel: "Cancelar",
      cancel_batch_warning: "Ira perder todas as publicações selecionadas. Tem certeza?",
      category: "Categoria",
      choose_another_brand: "Selecionar outra marca",
      choose_brand: "Selecione uma marca",
      condition_all: "Todos",
      condition_from_blacklisted_sellers: "De Vendedores Observados",
      condition_new: "Novo",
      condition_used: "Usado",
      condition_refurbished: "Recondicionado",
      "official-store": "Produto Oficial da Loja",
      languages: {
        es: "Español",
        en: "Inglés",
        pt: "Portugués",
      },
      countries: {
        AA: "Global",
        AR: "Argentina",
        AT: "Áustria",
        BE: "Bélgica",
        BO: "Bolívia",
        BR: "Brasil",
        CA: "Canadá",
        CH: "Suíça",
        CL: "Chile",
        CO: "Colômbia",
        CR: "Costa Rica",
        DE: "Alemanha",
        DO: "República Dominicana",
        RD: "República Dominicana",
        EC: "Equador",
        EN: "Inglaterra",
        ES: "Espanha",
        FR: "França",
        GB: "Reino Unido",
        GT: "Guatemala",
        HN: "Honduras",
        IE: "Irlanda",
        IT: "Itália",
        MX: "México",
        NI: "Nicarágua",
        NL: "Holanda",
        PA: "Panamá",
        PE: "Peru",
        PR: "Puerto Rico",
        PT: "Portugal",
        PY: "Paraguai",
        SC: "Escócia",
        SV: "El Salvador",
        US: "EUA",
        UY: "Uruguai",
        VE: "Venezuela",
      },
      country: "País",
      currency: "Moeda",
      date_finish: "Data de Término",
      date_start: "Data do Início",
      generated_by: "Gerado por",
      id: "Id",
      items_sold: "Itens vendidos",
      listing_lnk: "Link iten",
      listing_title: "Título do artigo",
      listing_type: "Tipo de anúncio",
      listings: "Publicações",
      location: "Localização",
      marketplace: "Mercado",
      marketplaces: "Mercados",
      offered_stock: "issoque ofertado",
      original_currency: "Moeda orig.",
      original_price: "Preço orig.",
      picture_1: "Imagem 1",
      picture_2: "Imagem 2",
      picture_3: "Imagem 3",
      picture_4: "Imagem 4",
      price: "Preço",
      price_range: "Faixa de preço",
      quantity: "Quantidade",
      removed_listings: "Itens Removidos",
      report_code: "Código de relatório",
      report_currency: "Moeda Relatório",
      report_date: "Data relatório",
      report_description: "Descrição relatório",
      report_tags: "Tags relatório",
      reported_listings: "Itens Relataram",
      reports: "Relatórios",
      required_words: "Palavras necessárias",
      search_by_marketplaces: "Pesquisa feita nos seguintes Marketplaces",
      search_terms: "Termos de Pesquisa",
      seller_username: "Usuário Vendedor",
      sellers_type: "Vendedores",
      seller: "Vendedor",
      snapshot: "Snapshot",
      sold: "Vendido",
      stock: "issoque",
      tag: "Tag",
      take_down_date: "Data de Término",
      report_status: "Estado Relatório",
      top_countries: "Top 5 Países",
      top_countries_by_publications: "Top 5 Países de acordo com o número de publicações",
      top_reported_sellers: "Top 5 Vendedores Relataram",
      top_sellers_by_publications: "Top 5 Vendedores de acordo com o número de publicações",
      total_value_reported_listings: "Valor Total dos Artigos Relatados",
      user: "Usuário",
      value_higher_than: "Superior a",
      value_less_than: "Menor que",
      volume_offered: "Volume ofertado",
      volume_reported: "Volume registado",
      volume_sold: "Volume vendido",
      worksheet_executive_summary: "Sumário Executivo",
      worksheet_listings: "Publicações",
      worksheet_marketplaces: "Mercados",
      worksheet_reported_listings: "Itens Relataram",
      worksheet_sellers: "Vendedores",
      worksheet_sellers_info: "* Alguns Mercados não oferecem dados sobre a quantidade e número de itens vendidos.",
      worksheet_tags: "Tags",
    },
  },
  exit_create_account: "Tem certeza de que quer sair?",
  create_auditor: "Agora você pode criar auditores de usuário",
  auditor_user: "Usuário de auditoria",
  name: "Nome",
  last_name: "Sobrenome",
  user_email: "E-mail",
  user: "Usuário",
  add_auditor: "Adicionar auditor",
  new_password_rules: "A senha deve ter mais de 8 caracteres e ser diferente da atual.",
  error_password_confirm: "As senhas devem corresponder",
  error_password_length: "A senha deve conter no mínimo 8 caracteres",
  wrong_password: "Nome de usuário ou senha incorretos",
  forgot_password: "Você esqueceu sua senha?",
  confirmation_code: "Código de verificação",
  enter_confirmation_code: "Insira o código de verificação",
  sent_to: "Nós o enviamos por e-mail para $email. Caso você não o encontre, confira na caixa de Spam.",
  did_not_receive: "Não recebi o código",
  yes: "Sim",
  no: "Não",
  wrong_confirmation_code: "Código de verificação incorreto",
  send_new_code: "Envie um novo código?",
  set_custom_password: "Por favor, defina a senha personalizada",
  create_user: "Criar usuário",
  create_users: "Criar usuários",
  continue_button: "Continuar",
  account_data: "Dados da conta",
  account_data_subtitle:
    "Com estes dados, você poderá vincular todos os seus usuários do Brand Protection Program e denunciar em diversos países ao mesmo tempo.",
  default_account: "Este será o usuário que você usará para entrar",
  user_already_exist: "Você já tem uma conta criada com este e-mail.",
  user_not_found: "O usuário não existe no país selecionado.",
  auditors: "Auditores",
  auditor: "Auditor",
  meli_token_authenticate_error: "Usuário incorreto. Por favor, entre com a sua conta do Brand Protection Program.",
  code_resend: "Encaminhamos o código para o seu email",
  account_welcome_message: "agora crie uma conta para usar a nova ferramenta de denúncias",
  account_created_title: "Pronto! Você se cadastrou na nova ferramenta",
  account_created_message: "Você já pode começar a denunciar em massa de forma mais fácil e eficiente com as novas ferramentas do Brand Protection Program.",
  create_account_success: "usuário criado com sucesso",
  main_account_info: "$account, por favor, lembre-se que:",
  account_created_reminder:
    "Se você geralmente denuncia no Brand Protection Program através de provedores que protegem seus direitos e, agora, você criou um usuário para denunciar diretamente, considere que as respostas às suas denúncias serão recebidas pelos provedores e eles podem não estar cientes da sua conta.",
  account_created_recomendation: "Portanto, recomendamos que você entre em contato e coordene o acompanhamento.",
  look_what_you_can_do: "Veja tudo o que você poderá fazer",
  create_account_error: "Ocorreu um erro quando criamos o usuário, tente mais tarde",
  export_xls: "Modelo de Exportação",
  "main-page-welcome-msg": "Renovamos nosso Brand Protection Program",
  "main-page-title": "Criamos novos processos para identificar vendedores infratores e os sancionamos muito mais rápido",
  "main-page-subtitle": "Além disso, oferecemos as melhores ferramentas:",
  "main-page-item-1": "Pesquise e relate facilmente em vários países ao mesmo tempo",
  "main-page-item-2": "Crie e salve seus próprios critérios de pesquisa",
  "main-page-item-3": "Escolha quais vendedores deseja focar e analise apenas suas publicações",
  "main-page-item-4": "Acesse um relatório com todas as publicações denunciadas e removidas",
  "main-page-item-5": "Adira e renove seus direitos com muito mais facilidade e rapidez",
  register_as_auditor: "Registre-se como auditor para começar a relatar e conhecer e Brand Protection Program",
  help_message: "Encontre tudo que precisa na seção de %{copy_help}",
  dont_know_how_to_start: "Não sabe como começar?",
  close_help_dialog_error: "Houve um erro enquanto fechamos o diálogo, por favor, tente mais tarde.",
  need_help: "¿Precisa de ajuda?",
  help: "Ajuda",
  help_href: "/noindex/pppi/support/",
  know_more_href: "https://www.mercadolivre.com.br/noindex/pppi/landings/bpp",
  register_href: "https://www.mercadolivre.com.br/noindex/pppi/rights/enroll/",
  contact_us: "Entre em contato conosco",
  buy_and_sell: "Compre e venda a partir do seu celular",
  enter_your_email: "Digite seu email",
  old_password: "Senha anterior",
  new_password: "Nova senha",
  new_password_confirm: "Confirmar Senha nova",
  password_changed_success: "Sua senha foi alterada com sucesso",
  password_changed_error: "Desculpe, sua senha não pode ser alterada, por favor tente mais tarde",
  enter_your_new_password: "Digite sua nova senha",
  password_confirmation: "Sua senha novamente",
  change_password: "Alterar senha",
  changing_password: "Mudando senha",
  send_email: "enviar",
  sending_email: "enviando email",
  sendind_email: "envio",
  failed_articles_message: "Essa Livesearch não pode ser completada exitosamente, houve %{count} artigos que não foram carregados",
  filter_profile: {
    attributes: "Atributos",
    brand: "Marca",
    allBrands: "Todas as marcas",
    model: "Modelo",
    allModels: "Todos as modelos",
    noOption: "Sem opções",
    "clarification-p1": "Ao clicar em ",
    "clarification-p2": "Aplicar e pesquisar, ",
    "clarification-p3": "suas preferências serão salvas automaticamente",
    all: "Todos",
    apply_filters: "Aplicar e pesquisar",
    article_condition: "Condição",
    categories: "Categorias",
    none_category: "Não",
    no_subcategories_for: "Não há subcategorias para",
    no_category_selected: "Você não marcou nenhuma categoria",
    info_categories_language: "Mostraremos as categorias no idioma do site onde você estiver buscando.",
    change: "Modificar",
    article_new: "Novos",
    article_used: "Usados",
    available_quantity: "Estoque oferecido",
    banned_keywords: "Termos a excluir",
    copy_of: "Copia de %{name}",
    "country.name": "País",
    "prices.USD": "Preço",
    date_range: "Rango de datas",
    default: "Predeterminada",
    extended_data_warning: "Isto irá trazer artigos somente de sitios que tenham esse tipo de informação.",
    extended_data_sites_list: "Sitios disponiveis: %{sites}.",
    fromPrice: "Mínimo",
    fromDate: "De",
    greater_than: "Maior que",
    no_name: "Sin nombre",
    portal: "Portal",
    price_range: "Preço",
    required_keywords: "Termos a incluir",
    seller: "Vendedores",
    seller_blacklisted: "Vendedores observados",
    no_seller_selected: "Você não selecionou nenhum vendedor",
    none_seller: "Nenhum",
    sold_quantity: "Estoque vendido",
    sort_by: "Ordenar por",
    select_sort_by: "Selecionar",
    title: "Perfis de filtros para Essa Livesearch",
    toPrice: "Máximo",
    toDate: "Até",
    select_one_site: "Selecione pelo menos um país",
    clean_filter: 'Limpar Filtros'
  },
  filter: "Editar filtros",
  clean_filter: "Limpar filtros",
  filtered: "Filtrados",
  filtered_results: "Resultados filtrados",
  filters_title: "FILTROS DE PESQUISA - Refinar resultados",
  forgot_your_password: "Esqueceu sua senha?",
  generating_report_results: "Gerando Resultados do Relatório",
  greater_than: "Maior que",
  home_title: "Brand Monitoring",
  in_progress: "em processo",
  processing: "processamento",
  language: "Idioma",
  live_search: "Livesearch",
  live_search_all_loaded: "Todos os resultados foram mostrados",
  live_search_fetch_error: "Sentimos muito mas houve un Erro quando estava sendo procurado a Livesearch. Por favor, tente novamente.",
  live_search_create_error: "Sentimos muito mas houve un Erro quando estava sendo criada a Livesearch. Por favor, tente novamente.",
  live_search_refresh_error: "Sentimos muito mas houve un Erro quando estava sendo atualizada a Livesearch. Por favor, tente novamente.",
  live_search_delete_error: "Sentimos muito mas houve un Erro quando estava sendo eliminada a Livesearch. Por favor, tente novamente.",
  live_search_filters: "Filtros de Pesquisa",
  live_search_loading_results: "Baixando mais resultados",
  live_search_queue_header: "FILA DE TRABAJO - Buscas realizadas e em processo",
  live_search_recent: "RECENTE",
  live_search_refinements_error: "Sentimos muito mas houve un Erro quando estavamos aplicando os filtros. Por favor, tente novamente.",
  live_search_reloading: "Executando de novo",
  live_search_results: "RESULTADOS FILTRADOS DE PESQUISA",
  live_search_empty: "Nenhum item foi carregado ainda",
  show_hidden_publications: "Ver anúncios ocultos",
  hidden_tooltip_text: "Ocultamos as publicações que você marcou como não-violadoras, que você já denunciou ou que pertencem a vendedores confiáveis.",
  in_moderation: "Reportados",
  validated: "Não infratores",
  denounced: "Reportados",
  multiple_selector: {
    advice: "Lembre-se de que você não pode usar a seleção múltipla para denunciar por direitos autorais de imagens.",
    trusted: "Confiáveis",
    suspicious: "Suspeitos",
    tooltip_text: "Você não pode usar esta função para denunciar usos não autorizados de imagens.",
    select_all_page: "Selecionar toda a página",
    max_selection_reached: "Máximo de 50 itens selecionados",
    selection_limit_reached: "Você atingiu o limite de produtos selecionados.",
    selection_limit_tooltip: "Você atingiu o limite de produtos que pode selecionar por dia.",
    selection_limit_info_tooltip: "Nesta página você só pode solicitar a denúncia de um número limitado de produtos, mas em geral pode escolher até 50 produtos por dia.",
    max: "máx.",
  },
  quick_search: "Busca rápida",
  quick_search_placeholder: "Busque por palavra-chave, código EAN ou número da peça",
  publication_id: "ID do anúncio",
  publication_id_placeholder: "MLB-745531777 o MLB745531777",
  publication_id_helper: "Encontre o ID completo na URL do anúncio. Você pode inserí-lo sem hífen.",
  seller_nickname: "Nome do vendedor",
  search_label_seller: "Palavras a buscar (opcional)",
  search_label_publication: "Busca rápida",
  url: "URL",
  no_matches: "Não há anúncios que correspondam à sua busca",
  no_matches_advice1: "Verifique a ortografia ou use palavras mais genéricas.",
  no_matches_advice2: "Tente excluir alguns dos termos.",
  no_matches_advice3: "Certifique-se de que o vendedor continue ativo no site.",
  no_matches_advice4: "Alterar filtros",
  nothing_here: "Nada por aqui...",
  you_did_not_do_any_search_yet: "Você ainda não possui nenhuma busca salva",
  live_search_empty_filtered: "Não há resultados para os filtros aplicados",
  live_search_status_count_error: "Ocorreu um erro ao procurar o número de estados dos artigos",
  live_search_processed_count_error: "Ocorreu um erro enquanto procurávamos os itens processados, tente mais tarde",
  live_search_new_processed_count: "Novos resultados disponíveis",
  loading: "Baixando...",
  loading_publications: "Baixando publicações...",
  loading_articles: "Baixando artigos",
  loading_brands: "Baixando marcas...",
  loading_live_searches: "Baixando Livesearches",
  loading_portals: "Baixando portales",
  loading_results: "Baixando Resultados",
  login: "Iniciar Sessão",
  loging_in: "Ingresando...",
  recover_password: "Recuperar senha",
  contact: "Contato",
  login_welcome_message: "Entre com o usuário e senha da nova ferramenta de denúncias",
  logout: "Finalizar Sessão",
  enroll_rights: "Adicionar direitos",
  new_profile: "Novo perfil",
  change_profile: "Alterar perfil",
  create_profile: "Criar",
  select_profile: "Selecione o perfil",
  create_profile_success: "Você criou com sucesso o perfil",
  create_profile_error: "Ocorreu um erro quando criamos o perfil",
  fetch_profiles_error: "Ocorreu um erro quando procuramos perfis disponíveis",
  change_profile_success: "Seu perfil foi alterado com sucesso.",
  change_profile_error: "Ocorreu um erro quando alteramos o perfil, tente mais tarde.",
  no_profiles: "Nenhum perfil disponível",
  create_account: "criar uma conta",
  lower_than: "menor que",
  mercadolibre: "Mercadolibre",
  money_saved: "Volume salvado",
  new_live_search: "Nova Livesearch",
  new_search: "Nova busca",
  new_product: "Produto novo",
  new_product_up: "Novo",
  other_sales_conditions: "Todas as condições de vendas",
  refurbished_product: "Produto Recondicionado",
  next: "Seguinte",
  no_data: "N/D",
  optional: "opcional",
  password: "Senha",
  create_user_password: "Senha",
  pending: "pendente",
  phone: "Tel",
  placeholder_avoided_keywords: "Adicione aqui as palavras a excluir",
  placeholder_required_keywords: "Adicione aqui as palavras a incluir",
  previous: "Anterior",
  price: "Preço",
  price_range: "Rango de Preços",
  prices_larger_than_currency: "Preços maiores que",
  prices_smaller_than_currency: "Preços menores que",
  quebarato: "Que Barato",
  refine_search_in_sites: "Refinar Pesquisa en Portales",
  remember_me: "Recordarme",
  repeat_password: "Repetir senha",
  report_label: "Marcar como suspeito",
  report_label_plural: "Marcar como suspeitos",
  edit_report_label: "Salvar alterações",
  report_article_error: "Sentimos muito mas não podemos enviar a denuncia do artigo. Por favor, tente novamente.",
  report_article_undo_error: "Sentimos muito mas não podemos desfazer. Por favor, tente novamente.",
  report_code: "Motivo de denúncia",
  report_code_2: "Motivo de Denuncia",
  report_description_label: "Outros comentários",
  report_description: "Descrição da denuncia",
  report_description_2: "Descrição Complementaria de Denuncia",
  report_placeholder: "Informe aqui suas impressões sobre o anúncio que você está prestes a reportar (opcional).",
  report_to_marketplace: "Reportar a Portal",
  report_status_takedown_submitted: "Takedown Submitted",
  report_status_listing_removed: "Listing Removed",
  report_status_takedown_failed: "Takedown Failed",
  reported_article: "Artigo denunciado",
  reported_to_site: "Reportado ao Portal",
  reports: "Reportes",
  reports_uppercase: "REPORTES",
  reported_by: "Reportado por",
  reputation_excelent: "Excelente",
  reputation_bad: "Ruim",
  reputation_good: "Boa",
  reputation_regular: "Regular",
  reputation_unknown: "Desconhecida",
  required_words: "Palavras requeridas",
  results_per_page: "Resultados por página",
  screenshoot: "Screenshot al momento de Denuncia",
  search_of_black_sellers_created: "Livesearch de todos os Vendedores Observados criada",
  searches: "Buscas",
  searches_uppercase: "BUSCAS",
  selected_articles: "Publicações Selecionadas",
  seller: "Vendedor",
  seller_blacklist: "Observar vendedor",
  black_seller: "Vendedor observado",
  seller_search_create: "Criar livesearch do vendedor",
  seller_search_created: "Livesearch do Vendedor criada",
  seller_white: "Vendedor confiavel",
  unset_seller_error: "Não foi possível atualizar as informações do vendedor. Tente novamente mais tarde",
  sellers: "Vendedores",
  sellers_black: "Vendedores observados",
  sellers_white: "Vendedores confiavels",
  send_me_reset_password_instructions: "Enviar instruções para resetear a senha",
  sending_report: "Enviando denuncia",
  settings: "Configuração",
  profile: "Perfil",
  show_current_listing: "Mostrar Livesearch do Vendedor",
  enter: "Entrar",
  entering: "Entrando",
  sign_in: "Iniciar sessão",
  signing_in: "Sessão inicial",
  sign_up: "Registrarse",
  site: "sitio",
  site_reputation: "Reputação",
  hello: "Oi",
  not_found: "Parece que esta página não existe",
  initial_page: "Ir para a home page",
  authorize_sites: "Vincular paises",
  authorized_site_message:
    "Vincule todas as contas que você usa no Brand Protection Program para denunciar em todos os países de uma vez. Basta digitar o usuário e senha de cada país.",
  authorized_site_title: "Notamos que você tem direitos para denunciar em mais países",
  authorized: "Autorizado",
  "new-authorize": "Novo",
  authorized_country: "Pronto! Você vinculou a conta",
  link_other_countries: "Vincular outros países",
  linked: "Vinculado",
  link: "Vincular",
  authorize_site_error: "ocorreu um erro ao autorizar o site, tente novamente mais tarde",
  authorize_site_error_not_pppi:
    "O usuário com quem você está tentando se autenticar não tem permissão para gerar um relatório, tente desatracar-se no Mercado Livre e tente novamente com o usuário correto.",
  incorrect_site_authentication:
    "Você tentou efetuar login com um usuário que não pertence ao país selecionado. Deve estar logado no Mercado Livre daquele país e tentar novamente com um usuário correspondente.",
  authorize_different_account: "Você tentou fazer login com um usuário que não pertence à sua conta.",
  go_to_main_page: "Começar a denunciar",
  start_reporting: "Começar a denunciar",
  sold: "ventas",
  sold_quantity: "vendidos",
  sort_by: "Ordenar resultados por",
  start_live_search: "Processar e buscar",
  "dont-repeat-livesearch": "Não pode haver livesearch repetidas",
  status: "Status",
  adding_reported_articles: "Adicionando Anúncios Suspeitos...",
  add_reported_articles_by_xlsx: "Adicionar Anúncios Suspeitos do Excel",
  submit_all_reported_articles: "Enviar todas as denúncias",
  submit_selected_reported_articles_s: "Enviar {10} denúncia",
  submit_selected_reported_articles_p: "Enviar {10} denúncias",
  submit_all_reported_articles_tooltip_pending_cn: "Você não pode enviar denúncias enquanto não revisar suas respostas pendentes.",
  submit_all_reported_articles_tooltip_restricted: "Restringimos suas denúncias enquanto analisamos se elas correspondem aos seus direitos aderidos.",
  submit_all_reported_ready: "Pronto! Enviamos suas denúncias.",
  submit_one_reported_ready: "Pronto! Enviamos suas denúncia.",
  submit_all_reported_ready_multiple_denounce: "Pronto! Para gerenciar e enviar suas denúncias, vá à seção Anúncios suspeitos.",
  submit_one_reported_ready_multiple_denounce: "Pronto! Para gerenciar e enviar suas denúncias, vá à seção Anúncios suspeitos.",
  submit_multiple_denounce_send_ready: "Pronto! Você denunciou os produtos.",
  filter_text: "Filtrar e ordenar",
  filter_text_2: "Filtrar",
  filter_modal: {
    filter_1: "Ordenar por",
    filter_2: "Motivo da denúncia",
    filter_3: "País",
    filter_4: "Por Estado",
    apply: "Aplicar filtros",
    apply_2: "Aplicar",
    clean: "Limpar filtros",
    filter_1_text_1: "Relatórios mais recentes",
    filter_1_text_2: "Relatórios mais antigos",
    all_reasons: "Todos os motivos de denúncia",
  },
  send: "Enviar",
  delete: "Excluir",
  search_text: "Buscar por # ou título",
  select_all: "Selecionar todos",
  selected_notices_s: "Tienes {10} denuncia seleccionada",
  selected_notices_p: "Tienes {10} denuncias seleccionadas",
  select_page: "Selecionar esta página",
  unselect_all: "Desmarcar todos",
  unselect_page: "Desmarcar esta página",
  clean_all_inactive_btn: "Limpar inativas",
  clean_one_inactive_btn: "Limpar inativa",
  clean_notices: "Excluir denúncias",
  clean_selected: "Excluir denúncias selecionadas",
  filters_applied: "Filtros aplicados",
  clean_all: "Excluir todas as denúncias",
  clean_inactive: "Excluir denúncias inativas",
  clean_all_inactive_ready: "Pronto! Excluímos suas denúncias.",
  clean_one_inactive_ready: "Pronto! Excluímos sua denúncia.",
  submit_report: "Enviar denúncia",
  submit_report_2: "Solicitar denúncia",
  edit_report: "Editar denúncia",
  submit_reported_articles: "Enviar denuncias",
  create_live_search_current_listings: "Criar Livesearch dos vendedores observados",
  questions_and_answers: "PERGUNTAS E RESPOSTAS",
  fetch_questions_and_answers_error: "Ocorreu um erro ao obter as perguntas e respostas.",
  support_form: {
    title: "suporte",
    subtitle: "Aqui, ajudaremos você a tirar todas as suas dúvidas sobre o Brand Protection Program.",
    textarea_label: "Digite sua pergunta",
    textarea_placeholder: "Com o que podemos ajudar?",
    send_to: "Nós responderemos para",
    submit: "Enviar pergunta",
    success_modal_title: "Já recebemos a sua mensagem!",
    success_modal_will_respond: "Responderemos por e-mail dentro das próximas 48 horas.",
    success_modal_cx_number: "O número da sua pergunta é ",
    success_modal_understood: "Entendi",
    error_message: "Não foi possível enviar a sua mensagem. Tente mais tarde.",
  },
  support: {
    title: "Seção Ajuda",
    contents: "Seção Ajuda",
    video: "https://www.youtube.com/embed/IZMQdZFFsGY",
    "contents-steps": {
      "sug-1-1": "Anúncios sugeridos",
      "sug-1-2": "Estatísticas",
      "sug-1-3": "Evolução semanal",
      "sug-1-4": "Marcar item",
      "1-1": "Realizar uma busca",
      "1-2": "Como realizar uma busca",
      "1-3": "Filtros de busca",
      "1-4": "Detalhes do anúncio",
      "2-1": "Avaliar um anúncio",
      "2-2": "Validar um anúncio como suspeito",
      "3-1": "Seleção múltipla",
      "3-2": "Como suspeito",
      "3-3": "Como confiável",
      "4-1": "Anúncios suspeitos a denunciar",
      "4-2": "Gerenciamento de artigos a denunciar",
      "8-1": "Anúncios do catálogo",
      "8-2": "O que é um anúncio de catálogo?",
      "8-3": "Como conhecer os vendedores participantes",
      "8-4": "Que dados o vendedor define",
      "8-5": "Quem responde as perguntas dos compradores",
      "8-6": "Como denunciar um anúncio de catálogo",
      "5-1": "Avaliar vendedores",
      "5-2": "Como avaliar vendedores",
      "5-3": "Como ver todos os vendedores confiáveis ou observados",
      "6-1": "Gerenciamento de denúncias",
      "6-2": "Denúncias pendentes",
      "7-1": "Adicionar novos direitos",
      "7-2": "Como adicionar novos direitos",
    },
    "answer-steps": {
      "sug-1-1": "Nesta seção, você verá os anúncios que encontramos com base nos nossos diagnósticos e no seu histórico de denúncias.",
      "sug-1-image": "01_POR_captura_Suger.png",
      "sug-2-1": "O objetivo deste complemento é deixar os anúncios suspeitos visíveis e prontos para denunciar.",
      "sug-2-2a": "O botão ",
      "sug-2-2b": "'Denunciar' ",
      "sug-2-2c": "direciona para ",
      "sug-2-2d": "'Anúncios suspeitos para denunciar'",
      "sug-3-1": "Aqui, você encontra um breve resumo do seu trabalho cumprido e poderá visualizar sua evolução na sua última semana.",
      "sug-3-2":
        "Os valores que também aparecem são o número de itens marcados como suspeitos e confiáveis na última semana. Lembre-se de que esses valores são retirados apenas dos itens sugeridos pelo Mercado Livre.",
      "sug-3-3":
        "O gráfico mostra o fluxo das denúncias diárias na última semana. Ao passar o mouse sobre o gráfico, você verá o valor da data específica selecionada.",
      "sug-3-4":
        "O percentual no marcador verde será exibido se a seu número de denúncias aumentar nessa seção e em vermelho caso tenha diminuído em comparação à semana anterior.",
      "sug-2-image": "02_POR_captura_Suger.png",
      "sug-3-2a": "Esta função permite que você ",
      "sug-3-2b": "marque elementos nos primeiros resultados ",
      "sug-3-2c":
        "para posteriormente acioná-los ou não perdê-los de vista. Além disso, permite fazer uma varredura rápida do que sugerimos e acumulá-los para depois focar na análise com mais critério.",
      "sug-3-image": "03_POR_captura_Suger.png",
      "1-1p1a": "Nesta seção você poderá realizar buscas de anúncios por ",
      "1-1p1b": "país* ",
      "1-1p1c": "usando diferentes ",
      "1-1p1d": "critérios de busca: ",
      "1-1p2t": "- Nome do anúncio",
      "1-1p2": "Busca usando palavras-chave relacionadas à sua marca ou direitos adicionados.",
      "1-1p3t": "- ID do anúncio",
      "1-1p3": "É o número que identifica de forma única cada anúncio no Mercado Livre.",
      "1-1p4t": "- Nome do vendedor",
      "1-1p4": "É o apelido do vendedor dentro do Mercado Livre.",
      "1-1p5t": "- URL do anúncio",
      "1-1p5": "É o link direto para um anúncio.",
      "1-1-clarification": "* Lembre-se de que você pode fazer buscas somente naqueles países que você tenha adicionado.",
      "1-1-image": "04_POR_captura_Suger.png",
      "1-2-1p1a": "No menu à esquerda, selecione ",
      "1-2-1p1b": "Buscar.",
      "1-2-2": "Selecione o critério de busca que vai usar e preencha o campo de busca.",
      "1-2-3a": "Indique o país no qual deseja buscar os anúncios. ",
      "1-2-3b": "Argentina ",
      "1-2-3c": "está configurada como padrão, mas você pode trocar de país quando quiser.",
      "1-2-4a": "Inicie a busca clicando em ",
      "1-2-4b": "Buscar.",
      "1-3a": "Uma vez dentro da lista de anúncios, você pode alterar os filtros de busca para refinar os resultados. Para isso, clique no ",
      "1-3b": "ícone de flecha ",
      "1-3c": "na parte superior esquerda e uma lista aparecerá com todos os filtros disponíveis.",
      "1-2-image": "05_POR_captura_Suger.png",
      "1-3-1-title": "Preço",
      "1-3-1-text": "Define a faixa de busca por preço mínimo e máximo dos produtos.",
      "1-3-2-title": "Condição",
      "1-3-2-text": "Se é um produto novo ou usado.",
      "1-3-3-title": "Categorias",
      "1-3-3-text": "Permite filtrar conforme as categorias de anúncios dentro do site.",
      "1-3-4-title": "Vendedores observados",
      "1-3-4-text": "Aplica a busca sobre todos os vendedores marcados como observados.",
      "1-3-7a": "Após selecionar os filtros, clique em ",
      "1-3-7b": "Aplicar e buscar.",
      "1-3-8": "* Lembre-se de que você pode fazer buscas somente naqueles países que você tenha adicionado.",
      "1-4":
        "Na tela de resultados, clique em um produto para ver seus detalhes. Lá você poderá ver as informações do anúncio, os dados e a reputação do vendedor, assim como o preço e as fotos do produto.",
      "1-3-image": "06_POR_captura_Suger.png",
      "2-1": "Validar um anúncio",
      "2-1-1": "A partir da lista de anúncios",
      "2-1-2a": "Passe o mouse sobre os anúncios. Clique nos botões SUSPEITO e CONFIÁVEL para validá-los.",
      "2-1-image": "07_POR_captura_Suger.png",
      "2-1-2b":
        "Se escolher o botão CONFIÁVEL, os anúncios desaparecerão dos resultados de busca automaticamente. Se escolher o botão SUSPEITO, poderá 'marcá-lo como suspeito' e colocar o motivo.",
      "2-2-image": "08_POR_captura_Suger.png",
      "2-2-1": "A partir dos detalhes do anúncio",
      "2-2-1a":
        "A partir daí, você poderá indicar com o botão CONFIÁVEL ou SUSPEITO se considera que esteja ou não violando alguns dos seus direitos adicionados.",
      "2-3-image": "09_POR_captura_Suger.png",
      "2-2-1b":
        "Todos os produtos que você já tenha validado como CONFIÁVEIS ou SUSPEITOS serão automaticamente excluídos dos seus próximos resultados de busca.",
      "2-3-1": "Validar um anúncio como suspeito",
      "2-3-2": "Se você acha que um artigo esteja violando um ou mais dos seus direitos, clique no botão SUSPEITO.",
      "2-3-3": "No menu à direita, junto aos detalhes do anúncio, você poderá marcar o motivo da denúncia do anúncio.",
      "2-3-4": "Os motivos são os seguintes.",
      "2-3-4a": "No produto:",
      "2-3-4a-1": "Produto falsificado",
      "2-3-4a-2": "Violação de direitos autorais",
      "2-3-4b": "No anúncio:",
      "2-3-4b-1": "Uso ilegal de marca registrada",
      "2-3-4b-2": "Uso não autorizado de imagens de terceiros",
      "2-3-4b-3": "Uso não autorizado de imagens pessoais",
      "2-4-1": "Uma vez que o motivo for selecionado e clicar em ",
      "2-4-2": "'Continuar'",
      "2-4-3": ", você poderá incluir um comentário. Depois, clique em 'Marcar como suspeito'.",
      "2-4-image": "10_POR_captura_Suger.png",
      "2-5-1": "Para enviar a denúncia sobre esse anúncio, entre na seção de 'Anúncios suspeitos a denunciar' no menu à esquerda.",
      "3-1-1": "Este complemento te permite marcar vários anúncios como ",
      "3-1-2": "'Confiáveis' ou 'Suspeitos' ",
      "3-1-3":
        "por vez, de forma ágil e rápida. Lembre-se de que você poderá marcar esses anúncios como suspeitos somente se eles compartilharem o motivo da denúncia.",
      "3-1-image": "11_POR_captura_Suger.png",
      "3-2-1": "Como marcar vários anúncios como 'Suspeitos'",
      "3-2-2":
        "Clique no botão 'Seleção múltipla' e marque como 'suspeitos' todos os anúncios que queira selecionar e verá que os anúncios marcados serão destacados em vermelho.",
      "3-2-3": "Toque no botão 'Aplicar' para marcá-los como suspeitos e continuar a denúncia.",
      "3-2-image": "12_POR_captura_Suger.png",
      "3-3-1": "Como marcar vários anúncios como 'Confiáveis'",
      "3-3-2":
        "Clique no botão 'Seleção múltipla' e marque como 'confiáveis' todos os anúncios que queira selecionar e verá que os anúncios marcados serão destacados em verde.",
      "3-3-3": "Toque no botão 'Aplicar' para que desapareçam da lista de busca.",
      "3-3-image": "13_POR_captura_Suger.png",
      "4-1-1": "Gerenciamento de artigos a denunciar",
      "4-1-2":
        "No menu à esquerda, na seção 'Anúncios suspeitos a denunciar', você encontrará todos os anúncios que marcou como possíveis violações, mas que ainda não denunciou.",
      "4-1-image": "14_POR_captura_Suger.png",
      "4-2-1": "Confirmar denúncia",
      "4-2-2a": "Se tiver certeza de que quer denunciar o anúncio, clique em ",
      "4-2-2b": "'Enviar denúncia'. ",
      "4-2-2c": "Para enviar todas as denúncias ao mesmo tempo, você pode clicar em ",
      "4-2-2d": "'Enviar todas as denúncias'.",
      "4-3-1": "Cancelar denúncia",
      "4-3-2": "Se quiser cancelar a denúncia, clique em ",
      "4-3-3": "'Ignorar'",
      "4-4-1": "Verificar detalhes",
      "4-4-2": "Se quiser verificar os detalhes da denúncia, clique no ícone  '+'.",
      "4-5-1": "Editar motivo da denúncia",
      "4-5-2a": "Se quiser alterar o motivo da denúncia, clique no botão ",
      "4-5-2b": "'Editar'",
      "4-5-2c": "e siga as etapas para incluir o novo motivo.",
      "5-1-1": "Nesta seção, você pode ver todos os vendedores que colocou em observação e aqueles que você considera confiáveis.",
      "5-1-image": "15_POR_captura_Suger.png",
      "5-2-1": "Como avaliar vendedores",
      "5-2-2": "Ao visualizar os detalhes de um anúncio, você verá três botões que permitem avaliar vendedores.",
      "5-3-1": "Vendedor observado",
      "5-3-2":
        "O vendedor receberá uma bandeirinha preta. Assim que identificar um vendedor como em observação, os produtos dele aparecerão destacados em suas buscas para que você possa identificá-los com mais facilidade.",
      "5-2-image": "16_POR_captura_Suger.png",
      "5-4-1": "Vendedor confiável",
      "5-4-2":
        "Quando você marca o vendedor como confiável, ele será automaticamente incluído na lista de vendedores confiáveis e os anúncios dele serão excluídos dos resultados de busca.",
      "5-5-1": "Criar livesearch do vendedor",
      "5-5-2a": "Crie uma ",
      "5-5-2b": "'Busca salva' ",
      "5-5-2c": "do vendedor e da categoria do produto, para que possa verificá-la mais tarde. Você pode acessá-la em Buscas, no menu à esquerda.",
      "5-6-1": "Vendedores observados",
      "5-6-2":
        "Nos detalhes do anúncio, clique no ícone de lupa ao lado do nome do vendedor. Assim, você verá todos os vendedores que marcou sob observação em suas buscas.",
      "5-6-3a": "Você pode acessar esta lista no menu à esquerda em ",
      "5-6-3b": "Vendedores > Vendedores observados.",
      "5-3-image": "17_POR_captura_Suger.png",
      "5-6-4":
        "O quadro mostra o país em que cada vendedor observado opera, assim como o seu nome de usuário no Mercado Livre, a quantidade de relatórios recebidos e a quantidade de produtos em sua lista de vendas.",
      "5-7-1": "Como revisar todos os artigos de vendedores observados",
      "5-7-2a": "Primeiro, clique em ",
      "5-7-2b": "'Criar uma nova livesearch' ",
      "5-7-2c": "dentro do quadro. Essa busca será salva na seção 'Buscas'.",
      "5-4-image": "18_POR_captura_Suger.png",
      "5-8-1": "Vendedores confiáveis",
      "5-8-2": "Aqui você verá todos os vendedores que marcou como confiáveis em suas buscas.",
      "5-8-3a": "Você pode acessar pelo menu à esquerda, em ",
      "5-8-3b": "Vendedores > Vendedores confiáveis.",
      "5-5-image": "19_POR_captura_Suger.png",
      "5-8-4": "O quadro mostra o país em que o vendedor opera, seu nome de usuário no Mercado Livre e a quantidade de produtos em sua lista de vendas.",
      "5-9-1": "Como verificar todos os artigos de vendedores observados",
      "5-9-2a": "Primeiro, clique em ",
      "5-9-2b": "'Criar uma nova livesearch' ",
      "5-9-2c": "dentro do quadro. Essa busca será salva na seção 'Buscas'.",
      "6-1-1": "Aqui você poderá acompanhar o status das suas denúncias e responder aos vendedores para decidir se quer confirmar ou retratar sua denúncia.",
      "6-1-image": "20_POR_captura_Suger.png",
      "6-2-1": "Exibe um quadro com todas as denúncias abertas. Clique em qualquer denúncia para ver os detalhes.",
      "6-2-2-title": "Resposta do vendedor",
      "6-2-2-text": "Exibe a data em que o vendedor enviou a resposta para sua denúncia, junto com as notas e arquivos anexos.",
      "6-2-3-title": "Denúncia",
      "6-2-3-text": "Exibe a data em que a denúncia do anúncio foi feita, o nome do auditor e o código único da denúncia.",
      "6-2-4-title": "Anúncio",
      "6-2-4-text": "É uma captura do anúncio tal e qual visualizado no dia em que a denúncia foi feita.",
      "6-2-5-title": "Dados do vendedor",
      "6-2-5-text":
        "Aqui você verá as informações do vendedor que anunciou o produto que você denunciou, como sua reputação no Mercado Livre, quantidade de denúncias enviadas, respostas recebidas e aceitas.",
      "6-2-6":
        "Se considerar a resposta suficiente e quiser excluir a sua denúncia, selecione o ícone de polegar para cima, mas se você considerar que a resposta não é suficiente, selecione o ícone de polegar para baixo.",
      "6-3-1": "Resposta do vendedor",
      "6-3-2a": "Nesta parte, você terá a chance de ",
      "6-3-2b": "'Confirmar ou recusar a denúncia' ",
      "6-3-2c": "e deixar um comentário para enviar ao vendedor.",
      "6-4-1": "Caso decida recusar a denúncia, você deve selecionar o motivo.",
      "6-2-image": "21_POR_captura_Suger.png",
      "7-2-1": "Se precisar incluir novos direitos para poder realizar mais e melhores denúncias, ",
      "7-2-1b": "clique aqui.",
      "7-2-2-title": "Na tela para adicionar direitos",
      "7-2-2-text": "Selecione a caixa de verificação do direito que deseja adicionar. Se precisar adicionar mais de um, pode selecionar múltiplas opções.",
      "7-2-3":
        "Para cada tipo de direito que você selecionar, um quadrado branco aparecerá na parte inferior da tela. Para cada caso anexe a documentação solicitada.",
      "7-2-4": "Ao terminar, clique no botão ",
      "7-2-5": "Enviar documentação.",
      "7-2-6": "Pronto! Nossos representantes vão analisar a sua documentação e notificar por e-mail sobre o status da sua solicitação.",
      "8-1-1": "Anúncios do catálogo",
      "8-2-1": "O que é um anúncio de catálogo?",
      "8-2-2": "Trata-se de uma 'página de produto' que agrupa, em um único conteúdo, vários anúncios oferecidos por diferentes vendedores.",
      "8-2-3":
        "Os anúncios dos vendedores competem pela primeira opção que os compradores veem. Quem oferecer as melhores condições de venda e experiência será o 'Ganhador'. A concorrência se baseia, entre outras coisas, no preço, na reputação do vendedor e nas condições de venda oferecidas.",
      "8-3-1": "Como conhecer os vendedores participantes",
      "8-3-2":
        "Observe que as 'páginas de produto' contêm variações. Por exemplo, para um celular, são apresentadas diferentes funções e cores disponíveis. Para cada combinação de variações, pode haver um ganhador diferente.",
      "8-3-3":
        "Ao encontrar um anúncio de catálogo na ferramenta de denúncias, você pode ir para os detalhes do anúncio para ver os vendedores participantes para cada variação.",
      "8-3-image": "22_POR_captura_Suger.png",
      "8-4-1": "Que dados o vendedor define",
      "8-4-2": "O vendedor configura as condições específicas do anúncio que participa do 'Catálogo'. Isso inclui preço, estoque, garantia e forma de envio.",
      "8-5-image": "23_POR_captura_Suger.png",
      "8-5-1": "Quem responde as perguntas dos compradores",
      "8-5-2": "Em um anúncio de catálogo, as respostas às perguntas dos compradores são dadas pelo vendedor ganhador do momento.",
      "8-5-3": "Na coluna 'Vendedores participantes', você pode ver as respostas dadas por cada vendedor. Basta selecioná-las.",
      "8-6-1": "Saiba mais sobre os Anúncios de catálogo",
      "8-7-1": "Como denunciar um anúncio de catálogo",
      "8-7-1-a": "Para denunciar as fotos do anúncio,",
      "8-7-1-b": " selecione a opção 'Marcar como suspeito' na seção que mostra os detalhes do produto.",
      "8-7-image": "24_POR_captura_Suger.png",
      "8-7-2-a": "Para denunciar o anúncio de um vendedor,",
      "8-7-2-b": "verifique a coluna 'Vendedores participantes' e clique no botão 'Marcar como suspeito'",
      "8-7-2-image": "25_POR_captura_Suger.png",
      "8-8-1": "Os anúncios que você marcar como suspeitos vão aparecer na seção ",
      "8-8-1-a": "'Denunciar anúncios suspeitos'",
      "8-8-1-b": "e você poderá gerenciá-las como de costume.",
    },
    "question-livesearch": "O que é uma Livesearch?",
    "answer-livesearch":
      "Livesearch é a busca de anúncios a partir de uma ou mais palavras-chave. Você pode fazer suas buscas por país ou em vários países de uma vez, sempre que estiver autorizado para denunciar em mais de um país. É importante que as palavras usadas estejam relacionadas à marca que você está auditando, assim, você pode obter resultados muito mais precisos.",
    steps: {
      "1-1": "No menu esquerdo, selecione",
      "1-2": "Buscas",
      "2-1": "Digite as palavras-chave e clique em",
      "2-2": "Buscar",
      "3-1": "Indique os países que quiser e selecione",
      "3-2": "Processar Busca",
      "4-1":
        "Quando o processo da livesearch iniciar, você verá a quantidade de anúncios que existem para as palavras-chave que você digitou. Ao clicar na(s) palavra(s)-chave que está(ão) na pesquisa, você poderá analisar os anúncios.  Você pode começar a auditar mesmo que a busca ainda esteja em andamento.",
    },
    "question-grid": "Grade de resultados",
    "answer-grid": "Na visão de grade de resultados, você encontrará todos os anúncios que correspondem às palavras-chave que você usou na sua Livesearch.",
    "question-filter-liversearch": "Filtros da livesearch",
    "answer-filter-liversearch1":
      "Depois de obter os resultados, você pode ajustar a busca e torná-la mais precisa usando os filtros. Você pode usá-los um a um ou combiná-los como preferir.",
    "answer-filter-liversearch2":
      "Você pode concentrar sua pesquisa em apenas uma linha de produtos da sua marca ou filtrar por data de anúncio, preço, estoque etc. Da mesma forma, você pode excluir palavras dos resultados.",
    "question-publication": "Visão detalhada do anúncio",
    "answer-publication":
      "Para acessar a visão detalhada, você deve clicar em um anúncio na grade de resultados. Na visão detalhada você terá mais informações sobre o item oferecido, suas fotos, informações do vendedor e análise de estoque e vendas atuais.",
    "question-publication-valid": "Polegar para cima",
    "answer-publication-valid":
      "Se você vê que um anúncio não está cometendo nenhuma infração à sua marca, indique, com o polegar para cima, que o anúncio é válido. Desta forma, em futuras buscas, esse anúncio não aparecerá novamente nos seus resultados.",
    "question-publication-invalid": "Polegar para baixo",
    "answer-publication-invalid1":
      "Se você vê que um anúncio está cometendo uma ou mais infrações de propriedade intelectual, você deve marcá-lo com o polegar para baixo. Em seguida, uma janela abrirá, onde você poderá adicionar mais detalhes sobre as infrações que detectou.",
    "answer-publication-invalid2": "Etiquetas",
    "answer-publication-invalid2-1":
      "Ao clicar em denunciar, a denúncia ainda não será processada e enviada para a equipe de revisão do Brand Protection Program. Ela será enviada para Produtos para denunciar, junto com as outras denúncias que você tenha feito. Portanto, se você identificar que uma denúncia não está correta, pode excluí-la antes que seja enviada.",
    "answer-publication-invalid3": "Código da denúncia",
    "answer-publication-invalid3-1":
      "É o código associado ao motivo da sua denúncia. Está relacionado aos direitos que você adicionou ao Brand Protection Program para denunciar no Mercado Livre.",
    "answer-publication-invalid4": "Detalhes",
    "answer-publication-invalid4-1":
      "Você pode adicionar detalhes do motivo da denúncia que você está prestes a fazer. Isso ajudará, caso algum membro da equipe precise de mais informações antes de processar uma exclusão.",
    "answer-publication-invalid5": "Denunciar",
    "answer-publication-invalid5-1":
      "Ao clicar em denunciar, a denúncia ainda não será processada e enviada para a equipe de revisão do Brand Protection Program. Ela será enviada para Produtos para denunciar, junto com as outras denúncias que você tenha feito. Portanto, se você identificar que uma denúncia não está correta, pode excluí-la antes que seja enviada.",
    "answer-publication-invalid6": "Produtos para denunciar",
    "answer-publication-invalid6-1":
      "Aqui estarão todos os anúncios que você marcou com o polegar para baixo. Neste caso, é onde você irá denunciar os anúncios. Portanto, é aconselhável rever todos os detalhes que você preencheu, para se certificar das infrações. Se você quiser, também pode visitar o anúncio no Mercado Livre, clicando no botão seguinte.",
    "answer-publication-invalid6-2": "Clicando em (+), poderá ver os detalhes da sua denúncia.",
    "answer-publication-invalid6-3": "Se você vê que um anúncio não está cometendo infração, pode selecionar Excluir da lista e a denúncia não será feita.",
    "answer-publication-invalid6-4":
      "Quando tiver certeza de que deseja enviar as denúncias, você pode enviá-las individualmente ou em massa, selecionando Enviar todas as denúncias.",
    "question-whitelistsellers": "Vendedores confiáveis",
    "answer-whitelistsellers1":
      "Você pode identificar vendedores como confiáveis (por exemplo, Lojas Oficiais, distribuidores etc.) para que seus anúncios não apareçam mais na livesearch e, desta forma, você não perca tempo auditando e analisando eles.",
    "answer-whitelistsellers2": "Para identificar um vendedor, você deve abrir a visão detalhada e clicar na ",
    "answer-whitelistsellers3": " de Vendedor confiável.",
    "question-blacklistsellers": "Vendedores observados",
    "answer-blacklistsellers1": "Se você achar necessário acompanhar alguns vendedores e todos os seus anúncios, basta selecionar Observar vendedor.",
    "answer-blacklistsellers2":
      "Todos os anúncios desse vendedor estarão marcados com a bandeira preta. Você também poderá filtrar os resultados para que mostrem somente anúncios de vendedores observados.",
    "answer-blacklistsellers3-1": "Você pode ver a atividade dos anúncios e denúncias desses vendedores no menu à esquerda, na seção ",
    "answer-blacklistsellers3-2": "Vendedores > Vendedores Observados",
    "question-livesearch-sellers": "Livesearches de vendedores",
    "answer-livesearch-sellers-1":
      "A partir da visão detalhada, na seção de Vendedores observados ou de Vendedores confiáveis, você pode criar uma livesearch para observar todos os anúncios desses vendedores.",
    "answer-livesearch-sellers-2":
      "Quando você identifica pelo menos um anúncio que viola os direitos da sua marca, é aconselhável analisar todos os anúncios do vendedor para verificar se há mais que poderiam afetar sua marca.",
    "question-post-denunciation": "Acompanhamento pós-denúncia",
    "answer-post-denunciation1-1":
      "Você poderá gerar relatórios de atividade e exportá-los como arquivo Excel. Você poderá acompanhar todo o trabalho de auditoria.",
    "answer-post-denunciation1-2":
      "Além disso, você poderá ver todos os anúncios denunciados que foram excluídos. Na hora de fazer a denúncia, você poderá ver uma foto de referência do anúncio.",
    "question-counter-notice": "Contranotificação",
    "answer-counter-notice1":
      "Se um vendedor fizer uma contranotificação de uma denúncia, ela chegará no e-mail que você informou como e-mail do contato ao cadastrar seus direitos no Brand Protection Program. Este e-mail corresponde ao associado às contas de denúncia do Brand Protection Program em cada país.",
    "answer-counter-notice2": "Lembre-se de que esse e-mail é diferente daquele que você cadastrou como auditor para denunciar nesta plataforma.",
    disclaimer: "*As imagens são mostradas como exemplo para explicar o uso da ferramenta.",
    "question-support": "SUPORTE",
    "see-more": "Dúvidas? Nós podemos ajudar.",
    "goto-support": "Acesse a seção de Ajuda",
  },
  black_sellers: {
    ID: "ID",
    title: "Últimos itens denunciados",
    placeholder_sites: "SELECIONAR SITES",
    table_th_site: "SITIO",
    table_th_country: "PAÍS",
    table_th_sellers: "VENDEDOR",
    table_th_reports: "REPORTES",
    table_th_actions: "AÇÕES",
    table_th_current_listings: "ANÚNCIOS ATUAIS",
    empty_sellers_message: "Nenhum Sellers Observados disponíveis.",
    button_create_current_listings: "Criar Livesearch com anúncios atuais",
    button_delete_current_listings: "Excluir",
    confirm_delete_client_black_seller: "Tem certeza que quer eliminar esse Vendedor da lista de Vendedores observável?",
    black_list_seller_deleted: "vendedor removido",
    black_list_seller_delete_error: "Houve um erro ao remover o vendedor",
    fetch_black_list_seller_error: "Desculpe, houve um erro na pesquisa de vendedores",
  },
  case_management: {
    cases: {
      pending_title: "Denúncias a responder",
      pending_table_explanation: "Os seguintes vendedores enviaram um Counter-Notice em suas solicitações para baixa de publicação",
      search: "Pesquisar",
      table_th_auditor: "Auditor",
      table_th_country: "País",
      table_th_id: "ID",
      table_th_article: "Anúncio",
      table_th_sellers: "Vendedor",
      table_th_status: "Status",
      table_th_denounce: "Data de Denúncia",
      table_th_denounce_2: "Data de denúncia:",
      table_th_denounce_sent: "Data de Denúncia",
      table_th_counter_notice: "Data de Resposta",
      table_th_response_limit: "Prazo de resposta",
      empty_cases_message: "Nehum resultado encontrado",
      fetch_pending_cases_list_error: "Desculpe, houve um erro na busca de casos",
      denounced_date: "Denunciado: ",
      updated_date: "Atualizado: ",
      canceled_date: "Cancelado: ",
      dates: "Ver datas",
    },
    case_description: {
      denounced_seller: "Vendedor denunciado",
      seller_response: "Isso é o que escreveram",
      seller_empty_response: "O vendedor não deixou comentários",
      photos_current: "Estas são as fotos atuais do anúncio",
      photos_modified_new: "NOVA",
      photos_denounced: "Estas são as fotos que você reportou",
      fetch_description_denounces_error: "Lo sentimos, hubo un error al buscar los datos.",
      no_data_found: "Nenhum dado encontrado",
      "counter-notice_tab": "Resposta do vendedor",
      "counter-notice": {
        counter_notice_attached_file: "ARQUIVO ANEXO",
      },
      denounce_tab: "Denúncia",
      denounce: {
        denounce_date: "DATA DA DENÚNCIA",
        auditor: "AUDITOR",
        code: "MOTIVO DA DENÚNCIA",
        additional_description: "NOTAS DO AUDITOR",
      },
      publication_tab: "Anúncio",
      publication: {
        site: "Mercado Livre",
        price: "PREÇO DO ANÚNCIO",
        product_sold_in_this_publication: "PRODUTOS VENDIDOS NESTE ANÚNCIO",
        description: "DESCRIÇÃO",
        images: "imagens",
        image: "image",
      },
      "seller-data_tab": "Dados do Vendedor",
      seller_data: {
        create_seller_LS: "Criar LiveSearch para este Vendedor",
        black_seller: "Vendedor Observado",
        portal_reputation: "Reputação",
        sold_quantity_products: "Quantidade de produtos vendidos",
        denonces_sent_to_this_seller: "Denúncias",
        counter_notice_received: "Respostas enviadas",
        counter_notice_accepted: "Respostas aceitas",
        denounces_table_article: "Anúncio",
        denounces_table_denounce: "Denúncia",
        denounces_table_status: "Estado",
        denounces_counter_notice: "Resposta do Venedor",
        fetch_counter_notices_error: "Ocorreu um erro ao receber as reclamações do vendedor",
      },
    },
    documentation_approved: {
      sending_response: "Estamos enviando sua respuesta para o vendedor.",
      response_placeholder: "Revisei a resposta e quero:",
      reject_option_member_placeholder: "Vou confirmá-la porque:",
      approved_case_title: "Resposta para o vendedor",
      approved_case_title_sent: "Resposta",
      confirm: "Confirmar minha denúncia",
      retract: "Retratar minha denúncia",
      confirm_helper_text: "Envie esta resposta para finalizar o anúncio.",
      retract_helper_text: "Envie esta resposta para reativar o anúncio.",
      send_response: "Enviar a resposta",
      reject_option_label: "Motivo da sua decisão",
      description_label: "Comentários adicionais",
      no_description: "Sem descrição",
      report_placeholder: "Explique ao vendedor por que você tomou esta decisão.",
      respond_counter_notice_success_confirm: "O anúncio foi excluído.",
      respond_counter_notice_success_retract: "O anúncio foi reativado.",
      respond_counter_notice_success: "Pronto! Já enviamos sua resposta ao vendedor.",
      respond_counter_notice_error: "Desculpe, houve um erro.",
      respond_counter_notice_rejected_by_abuse: "A justificativa não detalha uma infração. Por isso, reativamos o anúncio.",
      closed_title: "Você já respondeu para este vendedor",
      responded: "Esta foi a sua decisão",
      responded_at: "Você respondeu no dia",
    },
    publication_status: {
      active: "Ativa",
      closed: "Finalizada",
      inactive: "Inativa",
      paused: "Pausada",
      under_review: "Sob revisão",
    },
    denounce_status: {
      waiting: "Aguardando resposta",
      pending: "Respondida",
      accepted: "Anúncio reativado",
      not_approved: "Anúncio finalizado",
      not_presented: "Não respondido",
      not_respond: "Expirada",
      rollback: "Retirada",
      discard_due_restriction: "Descartada",
      pending_moderation: "Pendente",
      rejected: "Recusada",
      acuerdo_closed: "Anúncio finalizado",
      duplicated_denounce: "N/A",
      discarded: "Descartada",
      rejected_modified: "Anúncio modificado",
      revision: "Denúncia em revisão",
    },
    denounce_status_V3: {
      approved: "Aprovada",
      in_progress: "Em curso",
      pending: "Resposta pendente",
      rejected: "Recusada",
      rollback: "Retirada",
      discarded: "Descartada",
      not_respond: "Expirada",
      waiting: "Aguardando resposta",
      rejected_modified: "Anúncio modificado",
      dismissed: "Denúncia indeferida",
      listing_reactivated: "Anúncio reativado",
    },
    pending_denounce_widget: {
      title: "Denúncias pendentes de resposta.",
      subtitle: "Por favor, revise a resposta do vendedor",
    },
    status_pill: {
      expire_days: "Expira en {} dias",
      expire_day: "Expira en {} dia",
      expire_hours: "Expira en {} horas",
    },
  },
  welcome_page: {
    title: "Bem-vindo!",
    subtitle: "Você está a um passo de usar a nova ferramenta de denúncias do Mercado Livre",
    no_auditor_boton: "Quero me cadastrar",
    enter_now_to_denounce: "Já estou cadastrado",
  },
  welcome_register_page: {
    title: "Bem-vindo à ferramenta de denúncias do Brand Protection Program",
    subtitle:
      "Se você já está cadastrado no programa, entre com qualquer dos seus usuários do Brand Protection Program. Se você ainda não possui uma conta, cadastre-se.",
    subtitle2: "Informe o e-mail cadastrado no Brand Protection Program",
    email: "E-mail",
    singin_button: "Entrar",
    continue_button: "Entrar",
    no_account_button: "Fazer cadastro",
    know_more: "Conheça mais sobre o programa",
  },
  error_no_bpp: {
    title: "Não foi possível acessar sua conta",
    subtitlePart1: "Por favor, tente novamente e ",
    subtitlePart2: "certifique-se de usar suas credenciais do BPP.",
    btn: "Tentar novamente",
  },
  reported_articles: {
    send: "Enviar",
    delete: "Excluir",
    alerts: {
      cannot_submit_title: "Você não pode denunciar",
      cannot_submit_subtitle:
        "Identificamos comportamentos abusivos nas suas recusas às respostas dos vendedores, por isso você não pode enviar denúncias temporariamente.",
    },
    filters: {
      placeholder_reference_id: "ID",
      placeholder_title: "Título",
      placeholder_price_from: "Preço mín (USD)",
      placeholder_price_to: "Preço máx (USD)",
      placeholder_term: "Título",
      placeholder_site: "Selecione Sitio",
      placeholder_seller: "Selecione Vendedor",
      placeholder_complaint: "Status",
      placeholder_date_from: "DESDE",
      placeholder_date_to: "até",
      option_selecet_complaint_status_with_error: "Reintentar envío",
      option_selecet_complaint_status_without_error: "Não enviadas",
    },
    articles_reported: {
      title: "Histórico de denúncias",
      description: "Revise o status das suas denúncias e certifique-se de responder as que estiverem pendentes.",
      search: "Buscar por ID, ou nome do vendedor",
      filter: "Filtrar e ordenar",
      table_th_seller: "Vendedor",
      table_th_denounce: "Anúncio denunciado",
      table_th_reason: "Motivo da denúncia",
      table_th_status: "Status",
      placeholder_sites: "SELECIONAR SITES",
      table_th_id: "ID",
      table_th_site: "SÍTIO",
      table_th_country: "PAÍS",
      table_th_article: "PUBLICAÇĀO",
      table_th_auditor: "AUDITOR",
      table_th_price: "PREÇO",
      table_th_reported: "RELATADOS",
      table_th_notice_status: "STATUS",
      table_th_notice_update: "ÚLTIMA ATUALIZAÇÃO",
      table_th_down: "DERRUBAR",
      reported_at: "DATA DO RELATÓRIO",
      button_clear_filters: "Limpiar Filter",
      button_submit_filters: "Buscar",
      empty_reported_articles_message: "Não há artigos disponíveis relatados.",
    },
    denounce_status_tooltip: {
      WAITING_DOCUMENTATION: "O vendedor ainda não respondeu sua denúncia.",
      DOCUMENTATION_PRESENTED: "O vendedor já respondeu sua denúncia.",
      DOCUMENTATION_APPROVED: "Você decidiu reativar este anúncio.",
      DOCUMENTATION_NOT_APPROVED: "Você decidiu finalizar este anúncio.",
      DOCUMENTATION_NOT_PRESENTED: "Finalizamos o anúncio porque o vendedor não respondeu dentro do prazo.",
      MEMBER_NOT_RESPOND: "Você não respondeu ao vendedor no prazo e a denúncia expirou.",
      ROLLBACK: "Você decidiu reativar o anúncio, por ter retirado a sua denúncia.",
      DISCARDED_DUE_RESTRICTION: "O vendedor foi inativado, portanto não é necessário revisar sua resposta.",
      ACUERDO_CLOSED: "Nós finalizamos este anúncio.",
      DUPLICATED_DENOUNCE: "N/A",
      REJECTED: "Sua denúncia foi recusada.",
      REJECTED_BY_ABUSE: "A justificativa não detalha uma infração. Por isso, reativamos o anúncio.",
      REJECTED_BY_COUNTER_NOTICE: "A justificativa não detalha uma infração. Por isso, reativamos o anúncio.",
      DISCARDED: "O anúncio já foi excluído.",
      PENDING_MODERATION: "Sua denúncia ainda não foi aprovada",
      CREATED: "Sua denúncia ainda não foi aprovada",
      CROSS_DENOUNCE_CLOSED: "Sua denúncia foi recusada.",
      REJECTED_MODIFIED: "Não foi possível processar sua denúncia porque o anúncio foi modificado logo depois da sua denúncia.",
    },
    denounce_status_tooltipV3: {
      ACUERDO_CLOSED: "O anúncio denunciado foi excluído.",
      DOCUMENTATION_NOT_APPROVED: "A documentação do vendedor não foi aprovada. O anúncio denunciado foi excluído.",
      DOCUMENTATION_NOT_PRESENTED: "A sua denúncia foi aprovada porque o vendedor não apresentou a documentação.",
      CREATED: "A sua denúncia está pendente de processamento.",
      PENDING_MODERATION: "A sua denúncia está pendente de processamento.",
      WAITING_DOCUMENTATION: "O vendedor ainda não respondeu.",
      WAITING_FOR_PATCH_PDP: "Estamos analisando sua denúncia. Se necessário, faremos os ajustes apropriados.",
      DOCUMENTATION_PRESENTED: "O vendedor está esperando sua resposta. Caso você não responda, a denúncia será cancelada.",
      DUPLICATED_DENOUNCE: "A sua denúncia não pode ser feita por ser duplicada.",
      MEMBER_NOT_RESPOND: "A sua denúncia foi recusada porque você não respondeu ao vendedor dentro do prazo definido.",
      REJECTED: "A sua denúncia foi recusada por descumprir os requisitos necessários.",
      REJECTED_BY_ABUSE: "Sua justificativa não detalhava uma infração de propriedade intelectual. O anúncio foi reativado.",
      REJECTED_BY_ABUSE_COUNTER_NOTICE: "Sua justificativa não detalhava uma infração de propriedade intelectual. O anúncio foi reativado.",
      REJECTED_BY_COUNTER_NOTICE: "A sua denúncia foi recusada por descumprir os requisitos necessários.",
      REJECTED_BY_RESTRICTION: "Você excedeu o limite de denúncias por dia. Por favor, verifique a eficiência da sua conta.",
      DOCUMENTATION_APPROVED: "A documentação do vendedor foi aprovada e sua denúncia foi retirada.",
      ROLLBACK: "Você retirou a denúncia. O anúncio denunciado será reativado.",
      DISCARDED: "A sua denúncia não pode ser feita porque o anúncio está indisponível.",
      DISCARDED_DUE_RESTRICTION: "A sua denúncia não pode ser feita porque o vendedor está desativado.",
      REJECTED_MODIFIED: "A sua denúncia foi excluída porque o anúncio foi alterado.\n\n Saiba mais",
      REJECTED_PDP_CATALOG: "A sua denúncia foi excluída porque as imagens denunciadas foram retiradas de um banco de imagens.",
    },
    info_cn_message: {
      title: "Agora suas denúncias são resolvidas em menos tempo",
      description: "O prazo para resolver denúncias agora é de 6 dias: 3 dias para o vendedor responda à sua denúncia e 3 dias para você revise a resposta.",
      description_2: "Contamos todos os dias de segunda a sábado, inclusive feriados, ",
      description_2Strong: "mas não contamos os domingos.",
      description_3: " Por exemplo: se você fizer uma denúncia na sexta-feira às 10h, o vendedor terá até terça-feira no mesmo horário para responder.",
      description_4: "Com essa alteração, você gerencia suas denúncias com mais rapidez e protege sua marca com mais eficiência.",
      button: "Eu entendo"
    },
    index: {
      title: "artigos por denunciar",
      table_th_site: "SITIO",
      table_th_country: "PAÍS",
      table_th_article: "PUBLICAÇĀO",
      table_th_auditor: "AUDITOR",
      table_th_price: "PREÇO",
      table_th_antiquity: "REPORTADO HÁ",
      table_th_more: "MAIS",
      table_of_text: "de",
      table_next_text: "Próximo",
      table_rows_text: "linhas",
      table_page_text: "Página",
      table_previous_text: "Anterior",
      table_loading_text: "Carregando...",
      table_no_data_text: "Nenhuma linha encontrada",
      empty_reports_message: "não à artigos para reportar disponiveis.",
      removed_clarification: "Excluído",
      removed_clarification_tooltip: "Você não pode denunciar este anúncio, pois ele já foi excluído do site.",
      button_remove: "Excluir",
      removed: "Removido",
      removed_v2: "Anúncio inativo.",
      button_send_all_complaints: "Enviar todas as denúncias",
      button_edit_complaint: "Editar",
      button_send_complaint: "Enviar",
      button_retry_complaint: "Tentar Novamente",
      confirm_reported_article_undo: "Excluir este anúncio?",
      confirm_reported_article_undo_subtitle: "Ao fazer isso, você não verá mais $title na sua lista de anúncios suspeitos.",
      confirm_reported_article_undo_btn_label: "Excluir anúncio",
      confirm_send_all_complaints: "Você quer mesmo enviar todas as denúncias?",
      complaint_sent: "Denuncia enviada",
      send_complaint: "Obrigado por enviar este relatório. Continuaremos a avaliá-lo nas próximas 72 horas",
      send_all_complaints: "Obrigado por enviar essas reclamações. Vamos proceder a avaliá-las nas próximas 72hs.",
      error_send_all_complaints: "Houve um erro no envio das denuncias.",
      error_send_complaint: "Houve um erro no envio da denuncia.",
      error_send_complaint_already: "A publicação já foi denunciada.",
      error_getting_article_data: "Ocorreu um erro ao procurar os dados",
      failed_not_exits_or_not_published: "O artigo não existe ou não é publicado.",
      days: {
        one: "%{count} día",
        other: "%{count} días",
      },
    },
    edit: {
      seller: "Vendedor",
      tags: "Etiquetas",
      complaint_code: "Codigo de Denuncia",
      placeholder_complaint_description: "Informe aqui suas impressões sobre o anúncio que você está prestes a reportar (opcional).",
      label_add_tag: "Adicione suas etiquetas",
      cancel_complaint_edition: "Cancelar",
      edit_complaint_edition: "Editar",
    },
    table: {
      th1: "Anúncio suspeito",
      th2: "Preço",
      th3: "Vendedor",
      th4: "Motivo da denúncia",
    },
  },
  noticed_articles: {
    filter: "Filtrar",
    filters: {
      all: "Todos os status",
      placeholder_id: "ID",
      placeholder_title: "Titulo",
      placeholder_price_from: "PREÇO MÍN.",
      placeholder_price_to: "PREÇO MÁX.",
      placeholder_date_from: "Data de",
      placeholder_date_to: "Data para",
      placeholder_country: "Pais",
      placeholder_seller: "Vendedor",
      report_created: "relatório gerado",
      report_created_error: "Ocorreu um problema ao gerar o relatório",
      report_no_articles_found: "Nenhum artigo foi encontrado para gerar o relatório",
      title_required: "O título é obrigatório",
      date_error: "Data de não pode ser maior que a data para",
      price_error: "Preço desde que não pode ser maior a preço máx.",
    },
    // filter: "Filtrar",
  },
  client_white_sellers: {
    index: {
      ID: "ID",
      title: "Vendedores de Confiança",
      empty_sellers_message: "Nenhum vendedor confiável.",
      table_th_site: "SITIO",
      table_th_country: "PAÍS",
      table_th_seller_name: "VENDEDOR",
      table_th_seller_current_listing: "ARTIGOS ATUAIS",
      table_th_actions: "AÇÕES",
      delete_client_white_seller: "Excluir",
      confirm_delete_client_white_seller: "Tem certeza que quer eliminar esse Vendedor da lista de Vendedores Confiaveis?",
      white_list_seller_deleted: "vendedor removido",
      white_list_seller_delete_error: "Houve um erro ao remover o vendedor",
      fetch_white_list_seller_error: "Desculpe, houve um erro na pesquisa de vendedores",
    },
  },
  white_and_black_sellers: {
    filters: {
      ID: "ID",
      country: "Pais",
    },
  },
  notice_reports: {
    index: {
      title: "Denúncias",
      table_th_date: "data",
      table_th_name: "nome do relatório",
      table_th_download: "baixar",
      fetch_reports_error: "Opps... Ocorreu um erro enquanto procurávamos os relatórios, por favor tente mais tarde",
      click_here_to_download: "clique aqui para baixar",
      confirm_delete_report: "Tem certeza de que deseja excluir este relatório? Essa ação não pode ser desfeita.",
      delete_report_error: "houve um erro ao eliminar o relatório",
      processing_report: "relatório de processamento",
      generate_error: "Ocorreu um erro ao gerar este relatório",
      emply_error: "Desculpe, não há denúncias com os filtros selecionados",
    },
    create: {
      title: "Novo Relatório",
      create_report: "Criar Relatório",
      placeholder_title: "Titulo",
      placeholder_date_from: "Data de",
      placeholder_date_to: "Data para",
      placeholder_currency: "moeda",
      placeholder_origin: "auditor",
      placeholder_language: "idioma",
    },
  },
  livesearch_reports: {
    index: {
      title: "Denúncias",
      table_th_date: "Data",
      table_th_name: "nome do relatório",
      table_th_download: "baixar",
      fetch_reports_error: "Opps... Ocorreu um erro enquanto procurávamos os relatórios, por favor tente mais tarde",
      click_here_to_download: "clique aqui para baixar",
      confirm_delete_report: "Tem certeza de que deseja excluir este relatório? Essa ação não pode ser desfeita.",
      delete_report_error: "houve um erro ao eliminar o relatório",
      processing_report: "relatório de processamento",
      generate_error: "Ocorreu um erro ao gerar este relatório",
    },
  },
  sites_authorization: {
    from_account: {
      do_it_later: "Vincular depois",
      finish_and_do_it_later: "Concluir e vincular depois",
    },
    from_search: {
      back_to_search: "Voltar para a pesquisa",
    },
    default: {
      start_reporting: "Começar a denunciar",
    },
  },
  redirect_flow_info: {
    title: "Bem-vindo à nossa ferramenta de denúncias",
    subtitle: "Agora, denunciar e responder para os vendedores ficou muito mais rápido. Veja tudo que você pode fazer:",
    bullet1: "Identifique mais rapidamente os vendedores suspeitos",
    bullet2: "Crie seus filtros de busca",
    bullet3: "Acompanhe o status das suas denúncias em um só lugar",
  },
  tags_title: "Etiquetas",
  label_add_tag: "Adicione suas etiquetas",
  total: "Total",
  undo: "Desfazer",
  unknown_seller: "Vendedor desconhecido",
  unlist_seller_from_black_list_confirmation: "Tem certeza que quer eliminar esse Vendedor da lista de Vendedores Observados?",
  unlist_seller_from_white_list_confirmation: "Tem certeza que quer eliminar esse Vendedor da lista de Vendedores Confiaveis?",
  used_product: "Produto usado",
  validity: "Vigencia",
  view_in_site: "Visualizar no site",
  welcome: "Bem vindo/a",
  go_back: "Voltar",
  edit_reported_article_success: "O relatório para a publicação foi atualizado.",
  edit_reported_article_error: "Desculpe, ocorreu um erro ao atualizar o relatório.",
  done_article_reported: "Pronto! Para gerenciar e enviar suas denúncias, confira a seção",
  done_articles_reported: "Pronto! Para gerenciar e enviar suas denúncias, confira a seção",
  go_to_reported_articles: "Anúncios suspeitos.",
  we_will_send_this_listing_to: "Enviaremos este anúncio para",
  we_will_send_these_listing_to: "Enviaremos estes anúncios para",
  got_it: "ENTENDI",
  ls_reported_articles_link: "Ir para Anúncios suspeitos",
  process_and_clean_results: "Processar busca",
  live_searches: "Livesearches",
  unable_to_create_live_search: "Não foi possível criar a Liveserch intente novamente.",
  server_error: "Desculpe, ocorreu um erro no servidor, tente novamente",
  fetch_currency_error: "Desculpes, tivemos um erro na resposta da troca de moeda",
  remove_article_error: "Desculpe, tivemos um erro ao remover o artigo",
  remove_article_success: "Anúncio excluído.",
  fetch_seller_error: "Desculpe, tivemos um erro na pesquisa do vendedor",
  dashboard: "Dashboard",
  sellers_inactive: "Inactive Sellers",
  tags: "Tags",
  search: "Buscar",
  enter_your_email_below_to_reset_your_password: "Ingresse seu e-mail para resetear sua contraseña.",
  error_generating_custom_report: "Falha ao gerar resultadosrelatório personalizado.",
  without_results: "Sem resultados!",
  refresh: "Refrescar",
  try_again: "Tente novamente",
  seller_live_search_created: "Livesearch criado",
  create_seller_live_search: "Criar Livesearch com itens atuais",
  error_reporting_seller: "--Erro reportando o vendedor. Por favor, tente novamente.",
  error_user_without_report_profile: "--Não existe o Perfil do Reporte.",
  success_send_all_complaints: "--Foram enviadas todas as denuncias.",
  updated_reported_article_to_ok: "--Foi atualizado o estado do artigo denunciado para OK.",
  reported_article_not_found: "--Não foi encontrado o artigo reportado.",
  reported_article_already_reported: "--Tarde demais, artigo ja reportado.",
  update_reported_article_complaint_success: "--Foi atualizada a denuncia do artigo reportado.",
  update_reported_article_complaint_error: "--Não pode ser atualizada a denuncia do artigo reportado, por favor tente novamente.",
  complaint_reason: "Motivo de denúncia",
  complaint_error: "Erro na Denuncia",
  complaint_description: "--Descrição Complementaria da Denuncia",
  invalid_keyword_for_new_live_search: "--Deve agregar uma palavra chave para generar uma nova LiveSearch",
  modal_title: "Carregando...",
  response_errors: {
    client_error: "Erro do cliente",
    server_error: "Erro de servidor",
  },
  enroll_rights_cta_tooltip_header: "Lembre-se de que, antes de adicionar novos direitos, pediremos que você inicie sessão com seu nome de usuário.",
  enroll_rights_tooltip_content: "Não encontrou o motivo da infração na lista? Talvez você precise adicionar direitos.",
  enroll_rights_now: "Adicionar agora",
  report: {
    report_code: {
      PPPI1: "O produto oferecido é falsificado e infringe marca registrada (Ex.: Aplicação da minha marca registrada em produto não original, etc.).",
      PPPI2: "O anúncio utiliza marca de maneira ilegítima.",
      PPPI3: "O software oferecido é pirata/ilegal.",
      PPPI4: "O produto oferecido reproduz direito autoral sem autorização (Ex.: Reprodução de obras plásticas, fonogramas, audiovisuais e livros, etc.).",
      PPPI5: "O anúncio reproduz sem autorização, textos originais dos quais sou autor.",
      PPPI6: "O anúncio reproduz sem autorização, imagens originais (Ex.: fotografias, desenhos, pinturas, vídeos, etc.).",
      PPPI7: "O anúncio reproduz minha imagem pessoal sem autorização (Ex.: Retrato, modelo publicitário, etc.)",
      PPPI8: "O produto oferecido infringe desenho industrial.",
      PPPI9: "O produto oferecido infringe patente ou modelo de utilidade.",
      PPPI10: "Produto não destinado à venda",
      ACUERDO: "Tengo un convenio de regulación sobre este producto.",
    },
  },
  report_variants: {
    title_plural: "Marcar como suspeitos",
    title_s: "Marcar como suspeito",
    subtitle_copy: "Selecione o tipo de obra ou criação",
    subtitle_brand: "Selecione onde a infração aparece",
    subtitle_related: "Atores, cantores, músicos e dançarinos",
    subtitle_p: "Selecione o tipo de infração dos produtos. Observe que todas as variações serão denunciadas sob o mesmo motivo.",
    subtitle_s: "Selecione o tipo de infração do produto.",
    variant: "variação",
    variants: "variações",
    tooltip: "Agrupamos todas las denuncias que hiciste sobre las variantes en un mismo lugar.",
    alert: {
      hasCatalogo: {
        title: "Há condições de venda de catálogo na sua seleção",
        subtitle: "Alguns tipos de infração não se aplicam às denúncias que você faz aqui sobre condições de vendas de catálogo. Entretanto, elas são aplicáveis às denúncias sobre condições de venda tradicionais. ",
        subtitle2: "Acesse a página principal de cada condição para denunciar as condições de venda de catálogo."
      },
      allCatalogo: {
        title: "Não é possível denunciar algumas infrações para condições de venda de catálogo",
        subtitle: 'Observe que, a partir de agora, não será possível denunciar condições de venda de catálogo por “Uso ilegítimo de marca”, “Direitos autorais de imagens” e “Direitos autorais de imagem pessoal”. ',
        subtitle2: "Acesse a página principal de cada uma para denunciá-las."
      }
    }
  },
  report_v2: {
    title: "Marcar como suspeito",
    title_plural: "Marcar como suspeitos",
    subtitle: "Selecione o tipo de infração",
    title_product: "No produto oferecido",
    title_catalog: "Reportar infração aos meus direitos",
    subtitle_catalog: " Aplicável ao uso indevido de marcas, incluindo produtos falsificados ou produtos originais que usam uma marca sem autorização.",
    title_publication: "No conteúdo do anúncio",
    title_actors: "Atores, cantores, músicos e dançarinos",
    title_producers: "Produtores de videofonogramas",
    title_broadcastingorganizations: "Órgãos de radiodifusão",
    report_code: {
      PPPI1: "É um produto falsificado",
      PPPI2: "Uso ilegal da minha marca",
      PPPI3: "Software",
      PPPI4: "Infração de direitos de autor",
      PPPI5: "Livros",
      PPPI6: "Imagens / fotos",
      PPPI7: "Uso não autorizado da imagem pessoal",
      PPPI8: "Infringe modelos ou desenhos industriales",
      PPPI9: "Infringe patentes, modelos de utilidade ou variedades vegetais",
      PPPI10: "É um produto não destinado à venda",
      PPPI11: "Cursos",
      PPPI12: "Videogames",
      PPPI13: "Vídeos",
      PPPI14: "Vídeos / Filmes",
      PPPI15: "Música",
      PPPI16: "Personagens",
      PPPI17: "Outros",
      PPPI18: "Reproduções ilegais",
      PPPI19: "Imagem pessoal",
      PPPI20: "Uso não autorizado de material de aúdio",
      PPPI21: "Uso não autorizado de material audiovisual",
      PPPI22: "Transmissão ilegal",
      PPPI23: "Dispositivo ilegal",
      PPPI24: "Fotoproducto",
      ACUERDO: "Tenho um convênio de regulação sobre este produto.",
      PPPI1_subtext: "É um produto que tem minha marca mas que eu não fabriquei.",
      PPPI2_subtext: "Inclui meu logo nas imagens sem autorização. Identifica o produto com um nome ou logo que se confunde com a minha marca.",
      PPPI3_subtext: "O anúncio oferece um programa de computador que infringe meus direitos.",
      PPPI4_subtext: "Por exemplo, livros em PDF, músicas compiladas, cópias de filmes, produtos que incluem imagens de obras protegidas.",
      PPPI5_subtext: "O anúncio oferece uma obra literária que infringe meus direitos.",
      PPPI6_subtext: "O anúncio tem imagens ou fotos que infringem meus direitos.",
      PPPI7_subtext: "Por exemplo, uma foto que mostra uma pessoa sem sua autorização.",
      PPPI8_subtext: "Informe aqui as possíveis infrações aos seus modelos ou desenhos industriais registrados, incluindo desenhos, formas e monogramas.",
      PPPI9_subtext: "",
      PPPI10_subtext:
        "Ex.: amostras grátis ou produtos que foram entregues em regime de comodato. Produtos não lançados oficialmente no Brasil também podem ser denunciados.",
      PPPI11_subtext: "O anúncio oferece um curso que infringe meus direitos.",
      PPPI12_subtext: "O anúncio oferece um videogame que infringe meus direitos.",
      PPPI13_subtext: "",
      PPPI14_subtext: "O anúncio oferece uma obra audiovisual que infringe meus direitos.",
      PPPI15_subtext: "O anúncio oferece um conteúdo musical que infringe meus direitos.",
      PPPI16_subtext: "O anúncio oferece produtos que incluem meus personagens sem autorização.",
      PPPI17_subtext: "O anúncio oferece outro tipo de obra (desenho, pintura, escultura etc.) que infringe meus direitos.",
      PPPI18_subtext: "Inclusões ou reproduções não autorizadas.",
      PPPI19_subtext: "Uso não autorizado da minha imagem pessoal associada à minha interpretação artística.",
      PPPI20_subtext: "Música ou sons gravados.",
      PPPI21_subtext: "Filmes, séries, vídeos, gravações de recitais, shows e eventos esportivos.",
      PPPI22_subtext: "Serviços para acessar sinais ilegalmente.",
      PPPI23_subtext: "Dispositivos que captam sinais de acesso ilegalmente.",
      PPPI24_subtext: "O anúncio mostra fotos oficiais ou de catálogo sem autorização do titular da marca.",
      ACUERDO_subtext: "",
    },
    catalog_code: {
      PPPI1: "É um produto falsificado",
      PPPI2: "Uso ilegal da minha marca no anúncio.",
      PPPI10: "É um produto não destinado à venda",
      PPPI1_subtext: "É um produto com a minha marca, mas que não foi fabricado por mim.",
      PPPI2_subtext: "Identifica o produto com um nome ou logo que pode ser confundido com a minha marca, menciona a minha marca quando na verdade não é etc.",
      PPPI10_subtext:
        "Por exemplo: amostras grátis ou produtos entregues em regime de comodato. Além disso, é possível denunciar produtos não lançados oficialmente no Brasil. ",
    },
    step_2: {
      header: "Quer adicionar algo mais?",
      header_images: "Por que você está denunciando essas imagens?",
      subheader_images: "Explique qual direito de propriedade intelectual está sendo infringido nas imagens denunciadas.",
      docs_title: "Documentação anexada",
      docs_subtitle: "Selecione o documento com as imagens anexadas que você usará para respaldar seu caso.",
      title: "Adicionar comentário",
      subtitle: "(Opcional)",
      placeholder: "Inclui os detalhes da infração. Esses comentários aparecerão para o vendedor denunciado.",
      count: "A denúncia será aplicada a ",
      countStrong: "${count} variações",
      pppi8_subtitle: "Preencha as informações a seguir para reportar uma possível infração ao seu design registrado.",
      pppi8_field1_label: "Indique o número do seu registro pelo qual realiza a denúncia",
      pppi8_field1_placeholder: "Ex.: AR-123456, EU-78910, etc.",
      pppi8_field1_note: "Número de registro vigente.",
      pppi8_error_reg_number: "Erro ao carregar o número de registro",
      pppi8_field2_label: "Descreva quais partes do seu design são protegidas e como se diferenciam de outros designs comuns do mercado",
      pppi8_field2_placeholder: "Ex.: As alças curvas e o padrão diagonal são distintivos em relação a designs comuns de xícaras.",
      pppi8_field3_label: "Indique quais partes do seu design foram copiadas no produto denunciado, detalhando as similaridades específicas",
      pppi8_field3_placeholder: "Ex.: A forma da base e a proporção do corpo coincidem, gerando a mesma impressão geral.",
    },
    message_advice: {
      title: "IMPORTANTE",
      message:
        "Observe que sua denúncia deve se basear nas infrações de propriedade intelectual cadastradas no Brand Protection Program. O uso inadequado pode resultar em sanções na sua conta.",
      message_strong: "O uso inadequado dessa ferramenta pode fazer com que sua conta sofra sanções.",
      link: "Saiba o que pode ser denunciado",
    },
    tooltip_PPPI10: {
      title: "NOVO!",
      description: "Use este motivo para denunciar infrações de marca registrada sobre o produto.",
    },
    step_1: {
      copyright: "Infringe direitos autorais",
      copyright_fotoproducto: "Infringe direitos de fotoproduto",
      brand: "Infringe direitos de marca registrada",
      personal_image: "Usa minha imagem pessoal sem autorização",
      utility_model: "Infringe modelos ou desenhos industriales",
      patent: "Infringe patentes, modelos de utilidade ou variedades vegetais",
      agreements: "Tenho um convênio de regulação sobre este produto.",
      related_rights: "Infringe direitos conexos",
    },
    "select-options": {
      subtitle: "Onde a infração foi encontrada?",
      placeholder: "Selecione uma opção",
      "opt-title": "Título",
      "opt-description": "Descrição",
      "opt-sheet": " Ficha técnica",
      "opt-publish": "Anúncio",
      subtitle2: "Explique mais sobre a infração",
      placeholder2: "Inclua mais detalhes sobre a infração aqui.",
      button: "Enviar denúncia",
    },
    buybox: {
      title: "Pronto! Agradecemos por reportar",
      description: "Processamos a sua denúncia. Vamos revisá-la e te daremos uma resposta por e-mail.",
      "case-number": "Número do caso: ",
    },
    product_subtext_1: "Selecciona esta opción si el producto",
    product_subtext_2: "usa tu marca sin autorización",
    publication_subtext_1: "Selecciona esta opción si la publicación",
    publication_subtext_2: "menciona tu marca",
    publication_subtext_3: "en el titulo, en la ficha técnica o en la descripción.",
    related_rights_sub: "Verifique onde está a infração.",
    copyright_sub: "",
    brand_sub: "",
    personal_image_sub: "",
    utility_model_sub: "Informe aqui as possíveis infrações aos seus modelos ou desenhos industriais registrados, incluindo desenhos, formas e monogramas.",
    patent_sub: "",
    agreements_sub: "",
    copyright_title: "Selecione o tipo de obra ou criação",
    copyright_selected: " em ${reason}",
    utility_patent_selected: " de ${reason}",
    image_hub_title: "Indique qualis imagen(s) estariam infringindo seus direitos",
    catalog_title: "No produto oferecido",
    catalog_PPPI10_title: "No conteúdo do anúncio",
    "tooltip-isDenounced": "Este produto já foi reportado",
    errorDenounce: "Ocorreu um erro. Por favor, tente novamente. ",
  },
  datatables: {
    length_menu: "Mostrar _MENU_ filas por página",
    zero_records: "Não à resultados",
    info: "Mostrando _START_ de _END_ de _MAX_",
    info_empty: "Não à filas disponiveis",
    info_filtered: "(Filtrado desde _MAX_ resultados total)",
    processing: "Carregando resultados",
    first: "Primero",
    last: "Ultimo",
    next: "Próximo",
    previous: "Previo",
  },
  activerecord: {
    errors: {
      messages: {
        record_invalid: "objeto invalido -> %{Erros}",
        wrong_size: "tamaño equivocado (deveria ser %{file_size})",
        size_too_small: "demasiado pequeña (deve ser pelo menos %{file_size})",
        size_too_big: "demasiado grande (deveram ser pelo menos %{file_size})",
        inclusion: "não esta incluído na lista",
        exclusion: "está reservado",
        invalid: "é inválido",
        confirmation: "não coincide com a confirmação",
        blank: "é requerido",
        empty: "não pode estar vazio",
        not_a_number: "não é um número",
        not_an_integer: "deve ser um entero",
        less_than: "deve ser menor que %{count}",
        less_than_or_equal_to: "deve ser menor o igual que %{count}",
        greater_than: "deve ser maior que %{count}",
        greater_than_or_equal_to: "deve ser maior o igual que %{count}",
        too_short: {
          one: "é muito curto (mínimo 1 caracter)",
          other: "é muito curto (mínimo %{count} caracteres)",
        },
        too_long: {
          one: "é muito largo (máximo 1 caracter)",
          other: "é muito largo (máximo %{count} caracteres)",
        },
        equal_to: "deve ser igual a %{count}",
        wrong_length: {
          one: "longitude errada (deve ser de 1 caracter)",
          other: "longitude errada (deve ser de %{count} caracteres)",
        },
        accepted: "deve ser aceitado",
        even: "deve ser um número par",
        odd: "deve ser um número impar",
        taken: "ja registrado",
        required: "requerido",
      },
    },
    models: {
      user: "Usuario",
    },
    attributes: {
      user: {
        email: "Email",
        first_name: "Nombre",
        last_name: "Sobrenome",
        password: "Senha",
        password_confirmation: "Confirmar Senha",
        current_password: "Senha Actual",
        currency: "Moeda",
        locale: "Idioma",
        update_password: "Atualizar Senha",
        field_required: "Este campo é obrigatório",
        error_rewrite_password: "Não coincide com o campo contraseña",
        alert_update_user: "Usuário atualizado",
        alert_not_update_user: "Nenhuma alteração foi feita",
      },
    },
  },
  views: {
    pagination: {
      first: "&laquo; Primero",
      last: "Último &raquo;",
      previous: "&lsaquo; Ant",
      next: "Próximo &rsaquo;",
      truncate: "&hellip;",
    },
  },
  shared: {
    side_navigation: {
      suggested_listings: "Anúncios sugeridos",
      searches: "Buscas",
      reports: "Denúncias",
      custom_reports: "Relatórios de denúncias",
      last_reported_listings: "Histórico de denúncias",
      support: "Suporte",
      support_help: "Ajuda",
      management_case: "Gerenciamento de denúncias",
      cases_pending: "Denúncias pendentes",
      cases_closed: "Denúncias encerradas",
      sellers: "Vendedores",
      sellers_black: "Vendedores observados",
      sellers_white: "Vendedores confiavels",
      livesearch_reports: "Relatórios do Livesearch",
      articles_to_report: "Denunciar anúncios suspeitos",
      articles_to_report_tooltip_title: "Você possui denúncias não enviadas",
      articles_to_report_tooltip_text: "Revise seus anúncios suspeitos e envie suas denúncias por aqui.",
      articles_to_report_tooltip_not_show: "Não mostre novamente",
      support_link: "Suporte",
      video_instructions: "Vídeos instrutivos",
      new_pill: "NOVO",
      my_account: "Minha conta",
    },
  },
  devise: {
    registrations: {
      edit: {
        title: "Perfil do auditor",
        cancel_button: "Cancelar",
        update_button: "Atualizar",
        help_label_password: "(deixe em branco se você não quer mudá-lo)",
        help_label_current_password: "(precisamos de sua senha atual para confirmar as alterações)",
      },
    },
    passwords: {
      edit: {
        title: "Alterar sua senha",
        change_passwd_button: "Alterar minha senha",
        placeholder_password: "Nova senha",
        placeholder_confirm_password: "Confirmar nova senha",
      },
    },
    mailer: {
      reset_password_instructions: {
        hello: "OI",
        date: "Data",
        requested_link_text: "Alguem pediu um enlace para alterar sua senha. Você pode fazer isso através do seguinte link:",
        link_change_my_password: "alterar minha Senha",
        ignore_email_text: "Si Você não à solicitado a alteração do seu password, por favor, ignora essa mensagem.",
        your_passwd_wont_change_text: "Sua Senha não sera modificada até que ingresse no enlace de cima e gere uma nova.",
      },
    },
  },
  terms_and_conditions: "Termos e condições",
  privacy_policy: "Políticas de privacidade",
  reviews: {
    button: "Opiniões",
    title_seller_selected: "Opiniões sobre o produto de",
    title_default: "Opiniões sobre o produto",
    subtitle_seller_default: "Aqui, você encontra as opiniões de quem comprou de cada vendedor.",
    subtitle_seller_selected: "Confira as opiniões de quem comprou deste vendedor.",
    subtitle_seller_no_reviews: "O vendedor que você selecionou ainda não recebeu opiniões sobre as vendas que fez.",
    all_reviews: "Tudo",
    positives: "Positivas",
    negatives: "Negativas",
    view_more: "Ver mais",
    view_less: "Ver menos",
  },
  custom_reports: {
    title: 'Relatórios',
    no_result: 'Nenhum resultado encontrado para este período',
    no_reports: 'Nenhum relatório gerado',
    nav: {
      stats: 'Estatísticas',
      reports: 'Denúncias',
      generated: 'Relatórios gerados',
      reports_total: 'Total de denúncias:'
    },
    filter_options: {
      country: 'País',
      auditor: 'Auditor',
      state: 'Status',
      currency: 'Moeda',
      lang: 'Idioma',
      export_pdf: 'Baixar relatório',
      select_columns: 'Selecionar colunas',
      export_excel: 'Baixar relatório'
    },
    metrics_resumen: {
      title_panel: 'Painel de denúncias',
      title_reports: 'Total de denúncias',
      title_removed: 'Removidas',
      title_rechazed: 'Rejeitadas',
      title_reactived: 'Reativadas',
      title_progress: 'Pendentes de Revisão',
      info_progress: 'A denúncia está sendo processada internamente pelo sistema.'
    },
    graph_motivos: {
      title: 'Motivos mais denunciados',
      header_reason: 'Motivo',
      header_detail: 'Detalhe',
      header_report: 'Denúncias',
      header_percent: 'Porcentagem'
    },
    graph_country: {
      title: 'Países mais auditados',
      header_country: 'País',
      header_report: 'Denúncias enviadas',
      header_percent: 'Porcentagem'
    },
    list_sellers: {
      title_top_ten: 'Top dez vendedores mais denunciados',
      title: 'Vendedores mais denunciados',
      header_seller: 'ID do vendedor',
      header_report: 'Denúncias recebidas',
      header_location: 'Localização'
    },
    modal_print: {
      title: 'Exportar para',
      filename: 'Nome do arquivo',
      lang: 'Idioma',
      print: 'Gerar',
      report_date_range: 'Relatório de {{from}} a {{to}}'
    },
    details: {
      header_country: 'País',
      header_seller: 'Vendedor',
      header_id: 'ID da publicação',
      header_title: 'Nome da publicação',
      header_localPrice: 'Preço local',
      header_customPrice: 'Preço em',
      header_auditor: 'Auditor',
      header_reason: 'Motivo',
      header_status: 'Status',
      header_date: 'Data',
      not_results: 'Não foram encontrados resultados para sua busca',
      show: 'Mostrar',
      results_per_page: 'Resultados por página',
      previous: 'Anterior',
      next: 'Próximo',
      placeholder_search: 'Buscar por título, vendedor ou ID...',
      price_not_available: 'Não disponível',
      loading_prices: 'Carregando...'
    }
  },
  reportesV2: {
    all: 'Todos',
    select_columns: 'Selecionar Colunas',
    columns: {
      all: 'Todas',
      country: 'País',
      seller: 'Vendedor',
      id: 'ID da Publicação',
      title: 'Nome da publicação',
      localPrice: 'Preço Local',
      usdPrice: 'Preço em',
      auditor: 'Auditor',
      reason: 'Motivo',
      status: 'Status',
      date: 'Data'
    },
    states: {
      all: 'Todos',
      removed: 'Removidas',
      rejected: 'Rejeitadas',
      reactivated: 'Reativadas',
      in_progress: 'Em Progresso'
    },
    status_label: {
      removed: 'Removida',
      rejected: 'Rejeitada',
      reactivated: 'Reativada',
      in_progress: 'Em Progresso'
    }
  },
  massiveLoadV2: {
    upload_subtitle: "Envie seu arquivo Excel com as publicações para denunciar em lote",
    report_subtitle: "Relatório de carregamento em massa",
    error_subtitle: "Ocorreu um erro ao processar as informações",
    title: "Carregamento em massa de publicações suspeitas",
    back_to_start: "Voltar ao início",
    success_message: "Arquivo de lote processado com sucesso",
    ready_for_batch: "Prontos para processamento em lote",
    sample_data_title: "Amostra de dados carregados:",
    item_id_label: "ID do item:",
    code_label: "Código:",
    description_label: "Descrição:",
    more_elements: "... e {{count}} elementos a mais",
    view_details: "Ver Detalhes",
    invalid_code_format: "Formato inválido no campo code (linha {{line}}): deve ter apenas as opções permitidas",
    invalid_description_format: "Formato inválido no campo description (linha {{line}}): deve ter pelo menos 5 caracteres e conter apenas caracteres válidos",
    invalid_excel_format: "Formato inválido no Excel:\n\n{{errors}}\n\nPor favor, corrija estes erros e recarregue o arquivo.",
    batch_error: "Erro ao processar o lote: ",
    unknown_batch_error: "Erro desconhecido ao processar o lote",
    no_articles_loaded: "Não foi possível carregar nenhum artigo que foi importado",
    country_found: "País encontrado",
    countries_found: "Países encontrados",
    article_validation_failed: "Artigo com validação falhada",
    articles_validation_failed: "Artigos com validação falhada",
    summary_title: "Resumo",
    countries_loaded: "Países carregados",
    articles_count: "Quantidade de artigos",
    errors_by_type: "Quantidade de erros por tipo",
    not_found: "  - Não encontrados",
    duplicated: "  - Duplicados",
    validation_failed: "  - Validação falhada",
    validation_failed_label: "Validação falhada",
    blindages: "  - Blindagens",
    load_date: "Data de carregamento",
    line_number: "Número de linha",
    raw_field: "Campo carregado sem decodificar do excel",
    identified_article: "Artigo identificado",
    report: "Denúncia",
    description: "Descrição",
    all_lines: "Todas as linhas",
    item_id: "ID do item",
    reason: "Razão",
    due_date: "Data de vencimento"
  }
};

export default pt;
